(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8336],{

/***/ 7544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LI": function() { return /* binding */ reviewComponent; },
/* harmony export */   "ZP": function() { return /* binding */ ReviewsLanding; },
/* harmony export */   "il": function() { return /* binding */ SingleReview; }
/* harmony export */ });
/* unused harmony exports reviewSchema, SingleReviewDesktop */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9612);
/* harmony import */ var react_styled_flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4382);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1604);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(177);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4773);








var reviewSchema = zod__WEBPACK_IMPORTED_MODULE_5__.z.object({
    name: zod__WEBPACK_IMPORTED_MODULE_5__.z.string(),
    opinion: zod__WEBPACK_IMPORTED_MODULE_5__.z.string(),
    rating: zod__WEBPACK_IMPORTED_MODULE_5__.z.number(),
    avatar: zod__WEBPACK_IMPORTED_MODULE_5__.z.string()
});
var reviewComponent = zod__WEBPACK_IMPORTED_MODULE_5__.z.object({
    component: zod__WEBPACK_IMPORTED_MODULE_5__.z.literal("reviews"),
    title: zod__WEBPACK_IMPORTED_MODULE_5__.z.string(),
    subtitle: zod__WEBPACK_IMPORTED_MODULE_5__.z.string().optional(),
    without_background: zod__WEBPACK_IMPORTED_MODULE_5__.z.boolean().optional(),
    reviews: zod__WEBPACK_IMPORTED_MODULE_5__.z.array(reviewSchema)
});
function ReviewsLanding(props) {
    var reviews = props.reviews, title = props.title, subtitle = props.subtitle, without_background = props.without_background;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), offset = ref[0], setOffset = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative w-full py-[35px] tablet:py-[40px] desktop:py-[55px]",
            children: [
                !without_background && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "pointer-events-none absolute right-0 top-0 w-full -translate-y-1/4 overflow-hidden",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_1__/* .ResponsiveImage */ .t3, {
                        src: "/feature/background",
                        className: "w-full object-fill dark:opacity-40"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative flex w-full flex-col items-center gap-4 text-center tablet:gap-[26px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-[26px] font-800 leading-tight text-blue-900 tablet:text-[26px] desktop:text-[52px]",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-body-3 desktop:max-w-[800px]",
                            children: subtitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative hidden w-[1165px] flex-row desktop:flex desktop:items-center desktop:justify-center desktop:gap-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    disabled: offset === 0,
                                    onClick: function() {
                                        return setOffset(offset - 1);
                                    },
                                    className: "absolute left-0 z-20 hidden h-[50px] w-[50px] -translate-x-1/2 rotate-180 flex-row items-center justify-center rounded-full bg-color-cell shadow-2xl shadow-[#B7B7B70C] transition-colors inner-border inner-border-color-separator hover:bg-blue-100 disabled:opacity-0 desktop:flex",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Arrow, {})
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "relative z-0 w-full desktop:h-[350px]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "no-scrollbar absolute left-0 top-0 hidden w-full flex-row gap-5 overflow-x-scroll px-4 tablet:gap-4 tablet:px-5 desktop:flex desktop:h-[550px] desktop:w-full desktop:gap-6 desktop:overflow-x-hidden desktop:px-0",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            style: {
                                                left: "-".concat(offset * 395, "px")
                                            },
                                            className: "absolute top-0 hidden gap-5 transition-all duration-300 desktop:flex desktop:flex-row",
                                            children: reviews.map(function(review, index) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SingleReviewDesktop, {
                                                    review: review,
                                                    without_background: without_background,
                                                    avatar: review.avatar
                                                }, index);
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    disabled: offset + 3 === reviews.length,
                                    onClick: function() {
                                        return setOffset(offset + 1);
                                    },
                                    className: "absolute right-0 z-20 hidden h-[50px] w-[50px] translate-x-1/2 flex-row items-center justify-center rounded-full bg-color-cell shadow-2xl shadow-[#B7B7B70C] transition-colors inner-border inner-border-color-separator hover:bg-blue-100 disabled:opacity-0 desktop:flex",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Arrow, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "no-scrollbar flex w-full flex-row gap-5 overflow-x-scroll px-4 tablet:gap-4 tablet:px-5 desktop:hidden",
                            children: reviews.map(function(review, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SingleReview, {
                                    review: review,
                                    without_background: without_background,
                                    avatar: review.avatar
                                }, index);
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function SingleReview(props) {
    var avatar = props.avatar, review = props.review, without_background = props.without_background;
    var name = review.name, rating = review.rating, opinion = review.opinion;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("relative z-20 flex shrink-0 flex-col items-center gap-4 rounded-[12px] border border-color-separator px-5 py-4 tablet:px-[26px] tablet:py-10 desktop:w-[375px]", without_background ? "bg-blue-cell" : "bg-color-cell"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: avatar,
                    alt: name,
                    className: "h-[62px] w-[62px] rounded-full object-cover tablet:h-[122px] tablet:w-[122px] desktop:h-[62px] desktop:w-[62px]"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: " text-2xl font-700",
                    children: name
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_styled_flex__WEBPACK_IMPORTED_MODULE_2__/* .FlexItem */ .B5, {
                    box: true,
                    gap: 8,
                    alignSelf: "center",
                    children: Array(5).fill(0).map(function(_, i) {
                        return i < rating ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_7__/* .assetUrl */ .p)("/comps/star-full.svg"),
                            alt: "star icon"
                        }, i) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_7__/* .assetUrl */ .p)("/comps/star-empty.svg"),
                            alt: "star icon"
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "line-clamp-3 w-[229px] px-2 text-base font-400 text-color-placeholder tablet:px-0 desktop:w-[350px]",
                    children: "“".concat(opinion, "”")
                })
            ]
        })
    });
}
function SingleReviewDesktop(props) {
    var avatar = props.avatar, review = props.review, without_background = props.without_background;
    var name = review.name, rating = review.rating, opinion = review.opinion;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("relative z-20 flex shrink-0 flex-col items-center gap-4 rounded-[12px] border border-color-separator px-5 py-4 tablet:px-[26px] tablet:py-10 desktop:w-[375px]", without_background ? "bg-blue-cell" : "bg-color-cell"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: avatar,
                    alt: name,
                    className: "h-[62px] w-[62px] rounded-full object-cover tablet:h-[122px] tablet:w-[122px] desktop:h-[62px] desktop:w-[62px]"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: " text-2xl font-700",
                    children: name
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_styled_flex__WEBPACK_IMPORTED_MODULE_2__/* .FlexItem */ .B5, {
                    box: true,
                    gap: 8,
                    alignSelf: "center",
                    children: Array(5).fill(0).map(function(_, i) {
                        return i < rating ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_7__/* .assetUrl */ .p)("/comps/star-full.svg"),
                            alt: "star icon"
                        }, i) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_7__/* .assetUrl */ .p)("/comps/star-empty.svg"),
                            alt: "star icon"
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tooltip__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    className: "w-[229px] px-2 tablet:px-0 desktop:w-full",
                    showAlways: opinion.length > 165,
                    title: "“".concat(opinion, "”"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: " adesktop:w-[350px] aw-[229px] line-clamp-4 w-full text-base font-400 text-blue-600",
                        children: "“".concat(opinion, "”")
                    })
                })
            ]
        })
    });
}
var Arrow = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "11",
        height: "18",
        viewBox: "0 0 11 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.56961 1.36114L9.2085 9.00003L1.56961 16.6389",
            stroke: "#575757",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ }),

/***/ 5404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9612);
/* harmony import */ var _comps_text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(177);
/* harmony import */ var react_styled_flex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4382);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 9px;\n  margin: 9px;\n  gap: 9px;\n\n  background-color: var(--color-000);\n  border-radius: 12px;\n  box-shadow: 0 0 30px rgba(0, 0, 0, 0.13);\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var qrCodeImage = (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_5__/* .assetUrl */ .p)("/home/qrcode.webp");
var Container = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fdc7e17e-0"
})(_templateObject());
var QR = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                src: qrCodeImage,
                width: 450,
                height: 450
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_styled_flex__WEBPACK_IMPORTED_MODULE_4__/* .FlexBox */ .hs, {
                width: "140px",
                marginBottom: 9,
                style: {
                    lineHeight: "16px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_comps_text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    content: "txt_download_qr",
                    size: "14",
                    weight: "500",
                    color: "700"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (QR);


/***/ }),

/***/ 8336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Feature; },
  "featureSchema": function() { return /* binding */ featureSchema; },
  "templateComponent": function() { return /* binding */ templateComponent; },
  "templateComponentAlternative": function() { return /* binding */ templateComponentAlternative; },
  "useFeaturePage": function() { return /* binding */ _feature_useFeaturePage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./comps/text/index.tsx
var comps_text = __webpack_require__(64);
// EXTERNAL MODULE: ./utils/breakpoints.tsx
var breakpoints = __webpack_require__(1156);
// EXTERNAL MODULE: ./node_modules/react-styled-flex/dist/react-styled-flex.esm.js
var react_styled_flex_esm = __webpack_require__(4382);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./comps/bubble.tsx
var bubble = __webpack_require__(5232);
// EXTERNAL MODULE: ./comps/image.tsx + 1 modules
var comps_image = __webpack_require__(9612);
;// CONCATENATED MODULE: ./comps/feature/achievements.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  justify-content: center;\n  align-items: center;\n\n  flex: 1;\n\n  & + & {\n    border-left: solid 1px var(--color-separator);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n\n  justify-content: space-between;\n  align-items: center;\n\n  flex: 1;\n\n  & + & {\n    border-top: solid 1px var(--color-separator);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n\n  align-items: stretch;\n\n  width: 1000px;\n  height: 144px;\n\n  border-radius: 24px;\n\n  background-color: var(--color-background-cell);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n\n  align-items: stretch;\n\n  width: 728px;\n  height: 144px;\n\n  border-radius: 24px;\n\n  background-color: var(--color-background-cell);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n\n  align-items: stretch;\n\n  width: calc(var(--w-screen) - 32px);\n  margin: 0 16px;\n\n  border-radius: 12px;\n\n  background-color: var(--color-background-cell);\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








var Possibility = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-143734c6-0"
})(_templateObject());
var achievementSchema = lib.z.object({
    component: lib.z.literal("achievements"),
    actions: lib.z.array(lib.z.object({
        tablet: lib.z.boolean().optional(),
        action: lib.z.string(),
        value: lib.z.string(),
        unit: lib.z.string()
    }))
});
var Achievement = function(props) {
    var tablet = props.tablet, action = props.action, value = props.value, unit = props.unit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Possibility, {
        className: "z-20 bg-color-cell first:rounded-l-3xl last:rounded-r-3xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* FlexItem */.B5, {
                box: true,
                shrink: 0,
                paddingTop: 7,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_text/* default */.Z, {
                    content: action,
                    size: "18",
                    weight: "700",
                    capitalization: "uppercase"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* FlexItem */.B5, {
                box: true,
                shrink: 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_text/* RawText */.l, {
                    content: value,
                    size: tablet ? "32" : "36",
                    weight: "800"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* FlexItem */.B5, {
                box: true,
                shrink: 0,
                paddingBottom: 7,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_text/* default */.Z, {
                    content: unit,
                    size: "16",
                    weight: "400",
                    color: "600",
                    capitalization: "capitalize"
                })
            })
        ]
    });
};
var PossibilityMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-143734c6-1"
})(_templateObject1());
var AchievementMobile = function(props) {
    var action = props.action, value = props.value, unit = props.unit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PossibilityMobile, {
        className: "z-20 bg-color-cell first:rounded-t-3xl last:rounded-b-3xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_styled_flex_esm/* FlexBox */.hs, {
                column: true,
                margin: 20,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* FlexItem */.B5, {
                        box: true,
                        shrink: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_text/* default */.Z, {
                            content: action,
                            size: "18",
                            weight: "700",
                            capitalization: "uppercase"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* FlexItem */.B5, {
                        box: true,
                        shrink: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_text/* default */.Z, {
                            content: unit,
                            size: "16",
                            weight: "400",
                            color: "600",
                            capitalization: "capitalize"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* FlexItem */.B5, {
                box: true,
                shrink: 0,
                margin: 20,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_text/* RawText */.l, {
                    content: value,
                    size: "28",
                    weight: "800"
                })
            })
        ]
    });
};
var ContainerDesktop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-143734c6-2"
})(_templateObject2());
var ContainerTablet = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-143734c6-3"
})(_templateObject3());
var ContainerMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-143734c6-4"
})(_templateObject4());
var AllAchievements = function(props) {
    var actions = props.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative py-[35px] tablet:py-[40px] desktop:py-[55px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pointer-events-none absolute right-0 top-0 z-10 w-full -translate-y-1/3 overflow-hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* ResponsiveImage */.t3, {
                        src: "/feature/background",
                        className: "w-full object-fill dark:opacity-40"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "z-20 flex w-full flex-col items-center justify-center gap-[22px] tablet:gap-10 desktop:gap-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-row justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bubble/* default */.ZP, {
                                text: "your achievements",
                                color: "purplePink"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Desktop */.Hi, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerDesktop, {
                                children: actions.map(function(achievement) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Achievement, (0,_object_spread/* default */.Z)({}, achievement), achievement.action);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Tablet */.YD, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerTablet, {
                                children: actions.map(function(achievement) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Achievement, (0,_object_spread/* default */.Z)({
                                        tablet: true
                                    }, achievement), achievement.action);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Mobile */.ij, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerMobile, {
                                children: actions.map(function(achievement) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AchievementMobile, (0,_object_spread/* default */.Z)({
                                        tablet: true
                                    }, achievement), achievement.action);
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var achievements = (AllAchievements);

// EXTERNAL MODULE: ./utils/branch.ts
var branch = __webpack_require__(2404);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./sections/editor/editor.tsx
var editor_editor = __webpack_require__(5091);
// EXTERNAL MODULE: ./comps/button.tsx
var comps_button = __webpack_require__(5896);
;// CONCATENATED MODULE: ./comps/feature/benefits.tsx








var featureAiToolSchema = lib.z["enum"]([
    "deform",
    "ai_photo",
    "ai_restyle",
    "text_to_image",
    "text_to_video",
    "ai_music_generator", 
]);
var benefitSchema = lib.z.object({
    title: lib.z.string(),
    text: lib.z.string(),
    media: lib.z.string(),
    alt: lib.z.string().optional()
});
var benefitsSchema = lib.z.object({
    component: lib.z.literal("benefits"),
    head_title: lib.z.string(),
    button_link: lib.z.string().optional(),
    button_text: lib.z.string().optional(),
    bubble_text: lib.z.string(),
    benefits_list: lib.z.array(benefitSchema),
    upload: lib.z.boolean().optional(),
    tool: featureAiToolSchema.optional()
});
function Benefits(props) {
    var head_title = props.head_title, benefits_list = props.benefits_list, button_link = props.button_link, button_text = props.button_text, bubble_text = props.bubble_text, upload = props.upload, tool = props.tool;
    var onClick = (0,editor_editor/* useUploadOption */.Y4)(upload, tool).onClick;
    var editor = (0,editor_editor/* useEditorParamsContext */.mK)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-8 py-[35px] tablet:py-[40px] desktop:items-center desktop:py-[55px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full flex-col items-center gap-[22px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-row justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bubble/* default */.ZP, {
                                text: bubble_text,
                                color: "purplePink"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-h3 px-4 text-center desktop:max-w-[900px]",
                            children: head_title
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "no-scrollbar flex flex-row items-start gap-[34px] overflow-x-scroll px-4 tablet:justify-center tablet:gap-[20px] desktop:gap-[90px]",
                    children: benefits_list.map(function(benefit, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleBenefit, {
                            benefit: benefit,
                            image: benefit.media
                        }, index);
                    })
                }),
                button_text && tool !== "ai_music_generator" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                            href: button_link,
                            onClick: function() {
                                onClick && onClick();
                            },
                            loading: editor.loading,
                            className: "mt-8 hidden tablet:mt-0 tablet:!w-[275px] desktop:block",
                            text: button_text,
                            primary: true,
                            full: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                            href: branch/* appStoreConstant */.HY,
                            text: button_text,
                            primary: true,
                            full: true,
                            className: " tablet:mt-0 tablet:!w-[275px] desktop:hidden"
                        })
                    ]
                }),
                button_text && tool === "ai_music_generator" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                        loading: editor.loading,
                        primary: true,
                        full: true,
                        onClick: onClick,
                        text: button_text,
                        className: "mt-8 tablet:mt-0 tablet:!w-[275px]"
                    })
                })
            ]
        })
    });
}
function SingleBenefit(props) {
    var benefit = props.benefit, image = props.image;
    var title = benefit.title, text = benefit.text, alt = benefit.alt;
    var ref = (0,react.useState)(false), seeMore = ref[0], setSeeMore = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-[226px] shrink-0 flex-col items-center justify-center gap-[16px] text-center desktop:w-[302px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: image,
                    alt: alt !== null && alt !== void 0 ? alt : title,
                    className: "ah-[233px] w-full rounded-2xl object-cover desktop:h-[191px]"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-2 px-[3px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-h6 text-left",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (0,clsx_m/* default */.Z)("text-body-4 text-left text-blue-700 transition-all", seeMore ? "line-clamp-none" : "line-clamp-3"),
                            children: text
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: function() {
                                return setSeeMore(!seeMore);
                            },
                            className: (0,clsx_m/* default */.Z)("text-body-4 text-blue-600", text.length < 105 && "hidden"),
                            children: seeMore ? "less" : "see more"
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(2670);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./utils/cdn.ts
var cdn = __webpack_require__(177);
// EXTERNAL MODULE: ./utils/client-auth.tsx
var client_auth = __webpack_require__(1816);
// EXTERNAL MODULE: ./utils/functions.ts
var functions = __webpack_require__(2308);
// EXTERNAL MODULE: ./utils/notification.tsx
var notification = __webpack_require__(4371);
// EXTERNAL MODULE: ./node_modules/@kartyom/shared-components/dist/index.js
var dist = __webpack_require__(8976);
// EXTERNAL MODULE: ./utils/validators.ts
var validators = __webpack_require__(9480);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__(9204);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./comps/animated-words.tsx



function AnimatedWords(props) {
    var words = props.words;
    var ref = (0,react.useState)(0), currentNameIndex = ref[0], setCurrentNameIndex = ref[1];
    var ref1 = (0,react.useState)("typing"), animationState = ref1[0], setAnimationState = ref1[1];
    var ref2 = (0,react.useState)(""), typedCharacters = ref2[0], setTypedCharacters = ref2[1];
    (0,react.useEffect)(function() {
        if (words.length === 1) {
            setTypedCharacters(words[0].name.slice(0, typedCharacters.length + 1));
            return;
        }
        var typingTimer = setTimeout(function() {
            if (animationState === "typing") {
                if (typedCharacters.length < words[currentNameIndex].name.length) {
                    setTypedCharacters(words[currentNameIndex].name.slice(0, typedCharacters.length + 1));
                } else {
                    setTimeout(function() {
                        setAnimationState("deleting");
                    }, 800);
                }
            } else {
                if (typedCharacters.length > 0) {
                    setTypedCharacters(typedCharacters.slice(0, typedCharacters.length - 1));
                } else {
                    setAnimationState("typing");
                    setCurrentNameIndex(function(prevIndex) {
                        return (prevIndex + 1) % words.length;
                    });
                }
            }
        }, animationState === "typing" ? 150 : 90);
        return function() {
            return clearTimeout(typingTimer);
        };
    }, [
        typedCharacters,
        animationState,
        words,
        currentNameIndex, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,clsx_m/* default */.Z)(animationState === "typing" ? "animate-typing" : "animate-deleting", "inline-flex min-w-[200px] text-start text-[24px] font-800 tablet:text-[32px] desktop:text-[64px]", "overflow-hidden whitespace-nowrap dark:hidden"),
                style: {
                    color: words[currentNameIndex].lightColor
                },
                children: typedCharacters
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,clsx_m/* default */.Z)(animationState === "typing" ? "animate-typing" : "animate-deleting", "min-w-[200px] text-start text-[24px] font-800 dark:inline-flex tablet:text-[32px] desktop:text-[64px]", "hidden overflow-hidden whitespace-nowrap"),
                style: {
                    color: words[currentNameIndex].darkColor
                },
                children: typedCharacters
            })
        ]
    });
}

// EXTERNAL MODULE: ./comps/input.tsx
var input = __webpack_require__(5792);
// EXTERNAL MODULE: ./comps/message.tsx
var comps_message = __webpack_require__(9034);
// EXTERNAL MODULE: ./comps/subscription-popup.tsx + 1 modules
var subscription_popup = __webpack_require__(9460);
// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.module.js
var index_module = __webpack_require__(2010);
;// CONCATENATED MODULE: ./comps/feature/headline-alternative.tsx






















var tagSchema = lib.z["enum"]([
    "h1",
    "h2",
    "h3",
    "h4"
]);
var titleAttrSchema = lib.z.array(lib.z.object({
    start: lib.z.number(),
    length: lib.z.number(),
    color: lib.z.string().optional(),
    dark_color: lib.z.string().optional()
})).optional();
var headlineAlternativeSchema = lib.z.object({
    component: lib.z.literal("headline_alternative"),
    title: lib.z.string(),
    subtitle: lib.z.string().optional(),
    button_text: lib.z.string().optional(),
    placeholder: lib.z.string().optional(),
    isWaitlist: lib.z.boolean().default(false),
    inputIcon: lib.z.string().nullable().default(null),
    tag: tagSchema.optional().default("h1"),
    bubble_text: lib.z.string().optional(),
    title_attr: titleAttrSchema,
    inputType: lib.z.union([
        lib.z.literal("url"),
        lib.z.literal("text")
    ]).default("url"),
    words: lib.z.object({
        name: lib.z.string(),
        lightColor: lib.z.string(),
        darkColor: lib.z.string()
    }).array().optional()
});
function HeadlineAlternative(props) {
    var isUrl = function isUrl(str) {
        if (inputType !== "url") return true;
        try {
            new URL(str);
            return true;
        } catch (e) {
            return false;
        }
    };
    var title = props.title, subtitle = props.subtitle, button_text = props.button_text, bubble_text = props.bubble_text, placeholder = props.placeholder, isWaitlist = props.isWaitlist, inputIcon = props.inputIcon, words = props.words, title_attr = props.title_attr, inputType = props.inputType, tag = props.tag;
    var ref = (0,react.useState)(false), subscriptionPopupOpen = ref[0], setSubscriptionPopupOpen = ref[1];
    var ref1 = (0,react.useState)(""), text = ref1[0], setText = ref1[1];
    var router = (0,next_router.useRouter)();
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var notify = (0,react.useContext)(notification/* NotificationContext */.u).notify;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref2 = (0,input/* useValidator */.ny)(text, [
        validators/* notEmpty */.Dw,
        validators/* isEmail */.Jh
    ]), emailValidate = ref2.validate, emailErrors = ref2.errors;
    var ref3 = (0,react.useState)(false), isLoading = ref3[0], setIsLoading = ref3[1];
    function handleShareLink(message) {
        return _handleShareLink.apply(this, arguments);
    }
    function _handleShareLink() {
        _handleShareLink = (0,_async_to_generator/* default */.Z)(function(message) {
            var context, e, ref, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        if (userInfo.isAnonymous) {
                            router.push("/login?redirect_url=/chat?initial_message=".concat(message));
                            setIsLoading(false);
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        context = (0,functions/* isStringUrl */.b)(message);
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/wizard-start-session", {
                                context: context,
                                group: null,
                                tag: null
                            }).then(function(r) {
                                router.push("/chat?session_id=".concat(r.data.id));
                            })
                        ];
                    case 2:
                        _state.sent();
                        setText("");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        console.error(e);
                        if ((0,_instanceof/* default */.Z)(e, node_modules_axios/* AxiosError */.d7)) {
                            ;
                            if (((ref = e.response) === null || ref === void 0 ? void 0 : ref.status) === 431 || ((ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 432) {
                                setSubscriptionPopupOpen(true);
                            } else {
                                notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(comps_message/* ErrorMessage */.Bc, {
                                    children: t("txt_something_wrong")
                                }));
                            }
                        } else {
                            notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(comps_message/* ErrorMessage */.Bc, {
                                children: t("txt_something_wrong")
                            }));
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleShareLink.apply(this, arguments);
    }
    function handleWaitlistSubmit() {
        return _handleWaitlistSubmit.apply(this, arguments);
    }
    function _handleWaitlistSubmit() {
        _handleWaitlistSubmit = (0,_async_to_generator/* default */.Z)(function() {
            var from;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        from = String(router.query.slug || router.query.feature);
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/tool-waitlist-submit", {
                                from: from,
                                email: text
                            }).then(function() {
                                notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(comps_message/* SuccessMessage */.kk, {
                                    title: t("txt_waitlist_title"),
                                    children: t("txt_waitlist_desc")
                                }));
                            }).catch(function() {
                                notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(comps_message/* ErrorMessage */.Bc, {
                                    children: t("txt_something_wrong")
                                }));
                            })
                        ];
                    case 1:
                        _state.sent();
                        setText("");
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleWaitlistSubmit.apply(this, arguments);
    }
    (0,dist/* useShortCut */.Xg)({
        shortCut: "Enter",
        handler: function() {
            if (text.trim().length === 0 || isLoading || !isUrl(text)) {
                return;
            }
            if (isWaitlist) {
                handleWaitlistSubmit();
            } else {
                handleShareLink(text);
            }
        }
    });
    function handleSubmit(e) {
        return _handleSubmit.apply(this, arguments);
    }
    function _handleSubmit() {
        _handleSubmit = (0,_async_to_generator/* default */.Z)(function(e) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (isWaitlist ? emailErrors !== "" : text.trim().length === 0 || !isUrl(text)) return [
                            2
                        ];
                        if (!isWaitlist) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            handleWaitlistSubmit()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            handleShareLink(text)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleSubmit.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (0,clsx_m/* default */.Z)("flex flex-col items-center justify-center", "pb-5a pt-[35px] tablet:pt-[90px] desktop:pt-[150px]", "relative z-10 tablet:pb-[40px] desktop:pb-[80px]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,cdn/* assetUrl */.p)("/comps/headline-alternative-bg.webp"),
                        alt: "bg-picture",
                        className: "absolute left-0 top-0 -z-10 h-[330px] w-full dark:opacity-40 tablet:h-auto tablet:max-h-[600px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)("mb-[32px] flex flex-col gap-[22px] tablet:w-[579px]", "px-[16px] desktop:w-[696px]"),
                        children: [
                            bubble_text && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "z-[1] flex flex-row justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bubble/* default */.ZP, {
                                    text: bubble_text,
                                    color: "pinkPurpleLight"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GetHeader, {
                                tag: tag,
                                title: title,
                                title_attr: title_attr,
                                children: words && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedWords, {
                                    words: words
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-body-2 max-w-[800px] text-center",
                                children: subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: handleSubmit,
                        className: (0,clsx_m/* default */.Z)("flex rounded-[16px] bg-color-cell px-[12px] py-[12px]", "mx-[16px] w-full max-w-[343px] items-center gap-[16px]", "relative tablet:max-w-[718px] desktop:max-w-[774px]"),
                        style: {
                            boxShadow: "0px 7px 24px -10px rgba(111, 115, 212, 0.25)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                onChange: function(e) {
                                    return setText(e.currentTarget.value);
                                },
                                type: inputType,
                                onBlur: function() {
                                    if (!isWaitlist) return;
                                    emailValidate();
                                },
                                value: text,
                                placeholder: placeholder,
                                className: (0,clsx_m/* default */.Z)(inputIcon && "pl-[35px]", "w-full border-none bg-color-cell text-[16px] text-blue-800 outline-none")
                            }),
                            inputIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: inputIcon,
                                alt: "url icon",
                                className: (0,clsx_m/* default */.Z)("absolute left-[18px] top-1/2 w-[22px] -translate-y-1/2")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "submit",
                                disabled: (isWaitlist ? emailErrors !== "" : text.trim().length === 0 || !isUrl(text)) || isLoading,
                                className: (0,clsx_m/* default */.Z)("h-[42px] max-w-[42px] rounded-[8px] disabled:pointer-events-none", "flex items-center justify-center tablet:min-w-[162px]", "min-w-[42px] bg-primary-500 disabled:opacity-40 tablet:max-w-[162px]", "select-none self-end transition-colors hover:bg-primary-600"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-4 w-4 tablet:hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SendIcon, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "hidden text-[16px] font-600 text-color-white tablet:block",
                                        children: button_text
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(subscription_popup/* SubscriptionPopup */.yj, {
                isOpen: subscriptionPopupOpen,
                close: function() {
                    return setSubscriptionPopupOpen(false);
                },
                location: router.asPath
            })
        ]
    });
}
var SendIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10.5703 5.41407L6.7944 9.21516M6.7944 9.21516L2.37376 6.49431C1.79451 6.13772 1.91191 5.25798 2.56447 5.06858L13.0015 2.03162C13.595 1.85985 14.1438 2.4163 13.966 3.01259L10.8693 13.4388C10.6754 14.0913 9.80549 14.2043 9.45392 13.6217L6.7944 9.21516Z",
            stroke: "white",
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
function GetHeader(props) {
    var tag = props.tag, title = props.title, children = props.children, title_attr = props.title_attr, textStart = props.textStart;
    var resolvedTheme = (0,index_module/* useTheme */.F)().resolvedTheme;
    var formattedTitle = title;
    var lastText = "";
    if (title_attr) {
        var _loop = function(i) {
            var isColored = title_attr.some(function(param) {
                var start = param.start, length = param.length;
                return i >= start && i < start + length;
            });
            var attr = title_attr.find(function(param) {
                var start = param.start, length = param.length;
                return i >= start && i < start + length;
            });
            var color = "var(--color-primary-500)";
            if (attr && resolvedTheme === "dark" && attr.dark_color) {
                color = attr.dark_color;
            } else if (attr && attr.color) {
                color = attr.color;
            }
            if (isColored) {
                if (lastText) {
                    formattedTitle.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: lastText
                    }, i));
                    lastText = "";
                }
                formattedTitle.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        color: color
                    },
                    className: "text-[24px] font-800 leading-tight tablet:text-[32px] desktop:text-[64px]",
                    children: title[i]
                }, index));
            } else {
                lastText += title[i];
            }
            index++;
        };
        formattedTitle = [];
        var index = 0;
        for(var i = 0; i < title.length; i++)_loop(i);
        formattedTitle.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: lastText
        }, title.length));
    }
    switch(tag){
        case "h1":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                className: (0,clsx_m/* default */.Z)("whitespace-pre-line text-[32px] font-800 leading-[1.1] tablet:text-[32px] desktop:text-[64px]", textStart ? "self-center text-center tablet:self-start tablet:text-start" : "self-center text-center"),
                children: [
                    formattedTitle,
                    children
                ]
            });
        case "h2":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                className: (0,clsx_m/* default */.Z)("whitespace-pre-line text-[28px] font-800 leading-[1.1] tablet:text-[32px] desktop:text-[64px]", textStart ? "self-center text-center tablet:self-start tablet:text-start" : "self-center text-center"),
                children: [
                    formattedTitle,
                    children
                ]
            });
        case "h3":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                className: (0,clsx_m/* default */.Z)("whitespace-pre-line text-[24px] font-800 leading-[1.1] tablet:text-[32px] desktop:text-[52px]", textStart ? "self-center text-center tablet:self-start tablet:text-start" : "self-center text-center"),
                children: [
                    formattedTitle,
                    children
                ]
            });
        case "h4":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                className: (0,clsx_m/* default */.Z)("whitespace-pre-line text-[24px] font-800 leading-[1.1] tablet:text-[32px] desktop:text-[64px]", textStart ? "self-center text-center tablet:self-start tablet:text-start" : "self-center text-center"),
                children: [
                    formattedTitle,
                    children
                ]
            });
    }
}

;// CONCATENATED MODULE: ./comps/feature/call-to-action.tsx





















var call_to_action_tagSchema = lib.z["enum"]([
    "h1",
    "h2",
    "h3",
    "h4"
]);
var call_to_action_titleAttrSchema = lib.z.array(lib.z.object({
    start: lib.z.number(),
    length: lib.z.number(),
    color: lib.z.string().optional(),
    dark_color: lib.z.string().optional()
})).optional();
var callToActionSchema = lib.z.object({
    component: lib.z.literal("call-to-action"),
    title: lib.z.string(),
    subtitle: lib.z.string().optional(),
    inputIcon: lib.z.string().optional(),
    placeholder: lib.z.string(),
    button_text: lib.z.string(),
    isWaitlist: lib.z.boolean().default(false),
    tag: call_to_action_tagSchema.optional().default("h1"),
    bubble_text: lib.z.string().optional(),
    title_attr: call_to_action_titleAttrSchema,
    inputType: lib.z.union([
        lib.z.literal("url"),
        lib.z.literal("text")
    ]).default("url"),
    words: lib.z.object({
        name: lib.z.string(),
        lightColor: lib.z.string(),
        darkColor: lib.z.string()
    }).array().optional()
});
function CallToAction(props) {
    var isUrl = function isUrl(str) {
        if (inputType !== "url") return true;
        try {
            new URL(str);
            return true;
        } catch (e) {
            return false;
        }
    };
    var title = props.title, subtitle = props.subtitle, inputIcon = props.inputIcon, isWaitlist = props.isWaitlist, placeholder = props.placeholder, button_text = props.button_text, tag = props.tag, words = props.words, title_attr = props.title_attr, inputType = props.inputType;
    var ref = (0,react.useState)(false), subscriptionPopupOpen = ref[0], setSubscriptionPopupOpen = ref[1];
    var ref1 = (0,react.useState)(""), text = ref1[0], setText = ref1[1];
    var router = (0,next_router.useRouter)();
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var notify = (0,react.useContext)(notification/* NotificationContext */.u).notify;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref2 = (0,input/* useValidator */.ny)(text, [
        validators/* notEmpty */.Dw,
        validators/* isEmail */.Jh
    ]), emailValidate = ref2.validate, emailErrors = ref2.errors;
    var ref3 = (0,react.useState)(false), isLoading = ref3[0], setIsLoading = ref3[1];
    function handleShareLink(message) {
        return _handleShareLink.apply(this, arguments);
    }
    function _handleShareLink() {
        _handleShareLink = (0,_async_to_generator/* default */.Z)(function(message) {
            var context, e, ref, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        if (userInfo.isAnonymous) {
                            router.push("/login?redirect_url=/chat?initial_message=".concat(message));
                            setIsLoading(false);
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        context = (0,functions/* isStringUrl */.b)(message);
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/wizard-start-session", {
                                context: context,
                                group: null,
                                tag: null
                            }).then(function(r) {
                                router.push("/chat?session_id=".concat(r.data.id));
                            })
                        ];
                    case 2:
                        _state.sent();
                        setText("");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        console.error(e);
                        if ((0,_instanceof/* default */.Z)(e, node_modules_axios/* AxiosError */.d7)) {
                            ;
                            if (((ref = e.response) === null || ref === void 0 ? void 0 : ref.status) === 431 || ((ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 432) {
                                setSubscriptionPopupOpen(true);
                            } else {
                                notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(comps_message/* ErrorMessage */.Bc, {
                                    children: t("txt_something_wrong")
                                }));
                            }
                        } else {
                            notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(comps_message/* ErrorMessage */.Bc, {
                                children: t("txt_something_wrong")
                            }));
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleShareLink.apply(this, arguments);
    }
    function handleWaitlistSubmit() {
        return _handleWaitlistSubmit.apply(this, arguments);
    }
    function _handleWaitlistSubmit() {
        _handleWaitlistSubmit = (0,_async_to_generator/* default */.Z)(function() {
            var from;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        from = String(router.query.slug || router.query.feature);
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/tool-waitlist-submit", {
                                from: from,
                                email: text
                            }).then(function() {
                                notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(comps_message/* SuccessMessage */.kk, {
                                    title: t("txt_waitlist_title"),
                                    children: t("txt_waitlist_desc")
                                }));
                            }).catch(function() {
                                notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(comps_message/* ErrorMessage */.Bc, {
                                    children: t("txt_something_wrong")
                                }));
                            })
                        ];
                    case 1:
                        _state.sent();
                        setText("");
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleWaitlistSubmit.apply(this, arguments);
    }
    (0,dist/* useShortCut */.Xg)({
        shortCut: "Enter",
        handler: function() {
            if (text.trim().length === 0 || isLoading || !isUrl(text)) {
                return;
            }
            if (isWaitlist) {
                handleWaitlistSubmit();
            } else {
                handleShareLink(text);
            }
        }
    });
    function handleSubmit(e) {
        return _handleSubmit.apply(this, arguments);
    }
    function _handleSubmit() {
        _handleSubmit = (0,_async_to_generator/* default */.Z)(function(e) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (isWaitlist ? emailErrors !== "" : text.trim().length === 0 || !isUrl(text)) return [
                            2
                        ];
                        if (!isWaitlist) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            handleWaitlistSubmit()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            handleShareLink(text)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleSubmit.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (0,clsx_m/* default */.Z)("flex w-full flex-col items-center justify-center", "py-[40px] tablet:pt-[40px] desktop:pt-[120px]", "relative z-10 tablet:pb-[70px] desktop:pb-[120px]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,cdn/* assetUrl */.p)("/comps/headline-alternative-bg.webp"),
                        alt: "bg-picture",
                        className: "absolute bottom-0 left-0 -z-10 h-[280px] w-full rotate-180 scale-x-[-1] dark:opacity-40 tablet:h-auto tablet:max-h-[250px] desktop:max-h-[437px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)("mb-[32px] flex flex-col gap-[22px] tablet:w-[579px]", "px-[16px] desktop:w-[880px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GetHeader, {
                                tag: tag,
                                title: title,
                                title_attr: title_attr,
                                children: words && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedWords, {
                                    words: words
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "max-w-[800px] text-center text-[18px] font-400 text-blue-700",
                                children: subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: handleSubmit,
                        className: (0,clsx_m/* default */.Z)("flex rounded-[16px] bg-color-cell py-[8px] pl-[10px] pr-[8px]", "mx-[16px] w-full max-w-[343px] items-center gap-[16px]", "relative tablet:max-w-[718px] desktop:max-w-[660px]"),
                        style: {
                            boxShadow: "0px 7px 24px -10px rgba(111, 115, 212, 0.25)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                onChange: function(e) {
                                    return setText(e.currentTarget.value);
                                },
                                type: inputType,
                                onBlur: function() {
                                    if (!isWaitlist) return;
                                    emailValidate();
                                },
                                value: text,
                                placeholder: placeholder,
                                className: (0,clsx_m/* default */.Z)(inputIcon && "pl-[35px]", "w-full border-none bg-color-cell text-[16px] text-blue-800 outline-none")
                            }),
                            inputIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: inputIcon,
                                alt: "url icon",
                                className: (0,clsx_m/* default */.Z)("absolute left-[18px] top-1/2 w-[22px] -translate-y-1/2")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "submit",
                                disabled: (isWaitlist ? emailErrors !== "" : text.trim().length === 0 || !isUrl(text)) || isLoading,
                                className: (0,clsx_m/* default */.Z)("h-[42px] max-w-[42px] rounded-[8px] disabled:pointer-events-none", "flex items-center justify-center tablet:min-w-[162px]", "min-w-[42px] bg-primary-500 disabled:opacity-40 tablet:max-w-[162px]", "select-none self-end transition-colors hover:bg-primary-600"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-4 w-4 tablet:hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(call_to_action_SendIcon, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "hidden text-[16px] font-600 text-color-white tablet:block",
                                        children: button_text
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(subscription_popup/* SubscriptionPopup */.yj, {
                isOpen: subscriptionPopupOpen,
                close: function() {
                    return setSubscriptionPopupOpen(false);
                },
                location: router.asPath
            })
        ]
    });
}
var call_to_action_SendIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10.5703 5.41407L6.7944 9.21516M6.7944 9.21516L2.37376 6.49431C1.79451 6.13772 1.91191 5.25798 2.56447 5.06858L13.0015 2.03162C13.595 1.85985 14.1438 2.4163 13.966 3.01259L10.8693 13.4388C10.6754 14.0913 9.80549 14.2043 9.45392 13.6217L6.7944 9.21516Z",
            stroke: "white",
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ./comps/feature/faq.tsx





var questionSchema = lib.z.object({
    question: lib.z.string(),
    answer: lib.z.string()
});
var questionComponent = lib.z.object({
    component: lib.z.literal("faq"),
    questions: lib.z.array(questionSchema),
    style: lib.z.literal("large").optional()
});
function calculateDynamicHeight(text, width, index, questionIndex) {
    if (questionIndex === index) {
        var div = document.createElement("div");
        div.style.whiteSpace = "pre-line";
        div.style.position = "absolute";
        div.style.visibility = "hidden";
        div.style.width = width;
        div.style.padding = "20px";
        div.style.fontSize = "16px";
        div.style.fontWeight = "400";
        div.textContent = text;
        document.body.appendChild(div);
        var height = div.getBoundingClientRect().height;
        document.body.removeChild(div);
        return "".concat(height, "px");
    } else {
        return "0px";
    }
}
function FAQ(props) {
    var questions = props.questions, style = props.style;
    var ref = (0,react.useState)(-1), questionIndex = ref[0], setQuestionIndex = ref[1];
    if (style && style === "large") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQLarge, (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex w-full justify-center py-[35px] tablet:py-[40px] desktop:py-[55px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-[90%] flex-col items-center gap-5 tablet:w-[604px] desktop:w-[775px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-h5",
                        children: "Frequently Asked Questions"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex w-full flex-col items-center gap-4",
                        children: questions.map(function(question, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)("flex w-full flex-col overflow-hidden rounded-[10px] bg-color-background"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        onClick: function() {
                                            if (questionIndex === index) setQuestionIndex(-1);
                                            else setQuestionIndex(index);
                                        },
                                        className: (0,clsx_m/* default */.Z)("flex cursor-pointer select-none flex-row items-center justify-between p-4", questionIndex === index && "border-b border-color-separator"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (0,clsx_m/* default */.Z)("text-body-3 max-w-[95%] transition-colors duration-300", questionIndex === index && "text-primary-500"),
                                                children: question.question
                                            }),
                                            questionIndex !== index ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusLight, {})
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-1 flex-row justify-end",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus, {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            whiteSpace: "pre-line",
                                            "--desktop-size": calculateDynamicHeight(question.answer, "735px", index, questionIndex),
                                            "--tablet-size": calculateDynamicHeight(question.answer, "604px", index, questionIndex),
                                            "--mobile-size": calculateDynamicHeight(question.answer, "90%", index, questionIndex)
                                        },
                                        className: (0,clsx_m/* default */.Z)("max-h-[var(--mobile-size)] transition-all duration-300 tablet:max-h-[var(--tablet-size)] desktop:max-h-[var(--desktop-size)]"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-body-5 p-5",
                                            children: question.answer
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        })
    });
}
function FAQLarge(props) {
    var questions = props.questions;
    var ref = (0,react.useState)(-1), questionIndex = ref[0], setQuestionIndex = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "z-10 flex w-full justify-center py-[35px] tablet:py-[40px] desktop:px-[calc(50vw-702px)] desktop:py-[55px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-[90%] flex-col items-center gap-5 tablet:w-[604px] desktop:w-full desktop:flex-row desktop:items-start desktop:justify-between desktop:px-[30px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-center text-[26px] font-800 text-blue-900 tablet:text-[34px] tablet:font-800 desktop:max-w-[270px] desktop:text-start desktop:text-[52px] desktop:leading-[1.15]",
                        children: "Frequently Asked Questions"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex w-full flex-col items-center gap-4 desktop:w-[888px]",
                        children: questions.map(function(question, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)("flex w-full flex-col overflow-hidden rounded-[10px] bg-blue-100"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        onClick: function() {
                                            if (questionIndex === index) setQuestionIndex(-1);
                                            else setQuestionIndex(index);
                                        },
                                        className: (0,clsx_m/* default */.Z)("flex cursor-pointer select-none flex-row items-center justify-between p-4", questionIndex === index && "border-b border-color-separator"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (0,clsx_m/* default */.Z)("text-body-3 max-w-[95%] transition-colors duration-300", questionIndex === index && "text-primary-500"),
                                                children: question.question
                                            }),
                                            questionIndex !== index ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusLight, {})
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-1 flex-row justify-end",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus, {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            whiteSpace: "pre-line",
                                            "--desktop-size": calculateDynamicHeight(question.answer, "888px", index, questionIndex),
                                            "--tablet-size": calculateDynamicHeight(question.answer, "604px", index, questionIndex),
                                            "--mobile-size": calculateDynamicHeight(question.answer, "90%", index, questionIndex)
                                        },
                                        className: (0,clsx_m/* default */.Z)("max-h-[var(--mobile-size)] transition-all duration-300 tablet:max-h-[var(--tablet-size)] desktop:max-h-[var(--desktop-size)]"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-body-5 p-5",
                                            children: question.answer
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        })
    });
}
var PlusLight = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.33337 9.99992H16.6667M10 3.33325L10 16.6666",
            stroke: "var(--color-blue-900)",
            strokeWidth: "2",
            strokeLinecap: "round"
        })
    });
};
var Minus = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.33398 10.8655H16.6673",
            stroke: "var(--color-primary-500)",
            strokeWidth: "2",
            strokeLinecap: "round"
        })
    });
};

// EXTERNAL MODULE: ./utils/adjust.tsx + 1 modules
var adjust = __webpack_require__(6254);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 4 modules
var es = __webpack_require__(2512);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(2708);
// EXTERNAL MODULE: ./node_modules/react-spring/dist/react-spring.modern.mjs + 4 modules
var react_spring_modern = __webpack_require__(9926);
// EXTERNAL MODULE: ./comps/animate/display-trigger.tsx
var display_trigger = __webpack_require__(5467);
// EXTERNAL MODULE: ./comps/floating/index.tsx
var floating = __webpack_require__(501);
// EXTERNAL MODULE: ./styles/home/cover.module.css
var cover_module = __webpack_require__(5017);
var cover_module_default = /*#__PURE__*/__webpack_require__.n(cover_module);
;// CONCATENATED MODULE: ./comps/home/cover/icons.tsx




var AppStoreIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        href: branch/* appStoreConstant */.HY,
        target: "_blank",
        rel: "noopener noreferrer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: "app store icon light",
                "data-hide-on-theme": "dark",
                src: (0,cdn/* assetUrl */.p)("/icons/home/cover/app-store-light.svg"),
                className: (cover_module_default()).stores
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: "app store icon dark",
                "data-hide-on-theme": "light",
                src: (0,cdn/* assetUrl */.p)("/icons/home/cover/app-store-dark.svg"),
                className: (cover_module_default()).stores
            })
        ]
    });
};
var GooglePlayIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        href: branch/* playStoreConstant */.H2,
        target: "_blank",
        rel: "noopener noreferrer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: "google play icon light",
                "data-hide-on-theme": "dark",
                src: (0,cdn/* assetUrl */.p)("/icons/home/cover/google-play-light.svg"),
                className: (cover_module_default()).stores
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: "google play icon dark",
                "data-hide-on-theme": "light",
                src: (0,cdn/* assetUrl */.p)("/icons/home/cover/google-play-dark.svg"),
                className: (cover_module_default()).stores
            })
        ]
    });
};
var DesktopIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: "app store icon light",
                "data-hide-on-theme": "dark",
                src: (0,cdn/* assetUrl */.p)("/icons/home/cover/web-icon-light.svg"),
                className: "m-[7px] rounded-[6px] bg-color-cell"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: "app store icon dark",
                "data-hide-on-theme": "light",
                src: (0,cdn/* assetUrl */.p)("/icons/home/cover/web-icon-dark.svg"),
                className: "m-[7px] rounded-[6px] bg-color-cell"
            })
        ]
    });
};


// EXTERNAL MODULE: ./comps/home/cover/qr.tsx
var qr = __webpack_require__(5404);
// EXTERNAL MODULE: ./comps/simple-drop-area.tsx
var simple_drop_area = __webpack_require__(356);
;// CONCATENATED MODULE: ./comps/feature/headline.tsx




function headline_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	flex: 1;\n	height: 1px;\n\n	background-color: var(--color-separator);\n\n	margin: auto 0;\n"
    ]);
    headline_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function headline_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: row;\n"
    ]);
    headline_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




























var Separator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-482e4b04-0"
})(headline_templateObject());
var StoresContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-482e4b04-1"
})(headline_templateObject1());
var headline_featureAiToolSchema = lib.z["enum"]([
    "deform",
    "ai_photo",
    "ai_restyle",
    "text_to_image",
    "text_to_video",
    "ai_music_generator", 
]);
var headline_tagSchema = lib.z["enum"]([
    "h1",
    "h2",
    "h3",
    "h4"
]);
var headline_titleAttrSchema = lib.z.array(lib.z.object({
    start: lib.z.number(),
    length: lib.z.number(),
    color: lib.z.string().optional(),
    dark_color: lib.z.string().optional()
})).optional();
var headlineSchema = lib.z.object({
    component: lib.z.literal("headline"),
    bubble_text: lib.z.string().optional(),
    title: lib.z.string(),
    subtitle: lib.z.string(),
    button_text: lib.z.string().optional(),
    button_link: lib.z.string().optional(),
    media: lib.z.string(),
    without_background: lib.z.boolean().optional(),
    image_left: lib.z.boolean().optional(),
    without_qr: lib.z.boolean().optional(),
    upload: lib.z.boolean().optional(),
    tool: headline_featureAiToolSchema.optional(),
    tag: headline_tagSchema.optional().default("h1"),
    title_attr: headline_titleAttrSchema,
    left_icon: lib.z.string().optional(),
    right_icon: lib.z.string().optional(),
    className: lib.z.string().optional(),
    video_thumb: lib.z.string().optional(),
    words: lib.z.object({
        name: lib.z.string(),
        lightColor: lib.z.string(),
        darkColor: lib.z.string()
    }).array().optional(),
    style: lib.z.literal("large").optional(),
    platforms: lib.z.array(lib.z.union([
        lib.z.literal("ios"),
        lib.z.literal("android"),
        lib.z.literal("web"), 
    ])).optional(),
    logEvent: lib.z.union([
        lib.z.literal("header"),
        lib.z.literal("url_to_video"),
        lib.z.literal("script_to_video"),
        lib.z.literal("ai_avatars"), 
    ]).optional()
});
function HeadlineCover(props) {
    var updateInput = function updateInput(newValue) {
        inputHistory.push(text !== null && text !== void 0 ? text : "");
        if (inputHistory.length >= maxHistoryLength) {
            inputHistory.shift();
        }
        setText && setText(newValue);
    };
    var ref = (0,react.useState)(""), text = ref[0], setText = ref[1];
    var editor = (0,editor_editor/* useEditorParamsContext */.mK)();
    var bubble_text = props.bubble_text, title = props.title, subtitle = props.subtitle, button_text = props.button_text, button_link = props.button_link, media = props.media, without_background = props.without_background, without_qr = props.without_qr, image_left = props.image_left, upload = props.upload, tool = props.tool, platforms = props.platforms, tag = props.tag, componentStyle = props.style;
    var acceptedPlatforms = platforms !== null && platforms !== void 0 ? platforms : [
        "ios",
        "android",
        "web", 
    ];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var t = (0,esm/* useTranslation */.$G)().t;
    var notify = (0,react.useContext)(notification/* NotificationContext */.u).notify;
    var ref2 = (0,editor_editor/* useUploadOption */.Y4)(upload, tool), onDrop = ref2.onDrop, toolClick = ref2.onClick, formats = ref2.formats;
    var dropzoneState = (0,es/* useDropzone */.uI)({
        accept: (0,simple_drop_area/* getFormatsFromMimeTypes */.lz)(formats !== null && formats !== void 0 ? formats : [
            "image/png"
        ]),
        onDrop: onDrop,
        maxFiles: 1,
        maxSize: 10000000,
        noClick: true
    });
    function getMagic() {
        return _getMagic.apply(this, arguments);
    }
    function _getMagic() {
        _getMagic = (0,_async_to_generator/* default */.Z)(function() {
            var magicText, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/deforum-magic-prompt", {
                                tool: tool
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 2:
                        magicText = _state.sent();
                        setLoading(false);
                        updateInput(magicText);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error);
                        setLoading(false);
                        notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(comps_message/* ErrorMessage */.Bc, {
                            children: t("txt_could_not_get_magic")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _getMagic.apply(this, arguments);
    }
    var ref3 = (0,react.useState)([]), inputHistory = ref3[0], _ = ref3[1];
    var maxHistoryLength = 50;
    (0,react.useEffect)(function() {
        var handleUndo = function(e) {
            if (e.ctrlKey && e.key === "z" || e.metaKey && e.key === "z") {
                if (inputHistory.length > 0) {
                    var ref;
                    setText && setText((ref = inputHistory.pop()) !== null && ref !== void 0 ? ref : "");
                }
            }
        };
        window.addEventListener("keydown", handleUndo);
        return function() {
            window.removeEventListener("keydown", handleUndo);
        };
    }, [
        text,
        inputHistory,
        setText
    ]);
    if (componentStyle && componentStyle === "large") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadlineLarge, (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative flex w-full justify-center pt-[16px] tablet:py-[40px] desktop:py-[55px]",
            children: [
                !without_background && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pointer-events-none absolute right-0 top-0 w-full -translate-y-1/4 overflow-hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* ResponsiveImage */.t3, {
                        src: "/feature/intro",
                        className: "w-full object-cover"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("flex justify-center tablet:w-[720px] tablet:items-center tablet:justify-between desktop:w-[950px]", image_left ? "tablet:flex-row-reverse" : "tablet:flex-row"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-[90%] flex-col items-center gap-2 tablet:max-w-[370px] tablet:items-start tablet:gap-3 desktop:max-w-[517px]",
                            children: [
                                bubble_text && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "z-[1] flex flex-row justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bubble/* default */.ZP, {
                                        text: bubble_text,
                                        color: "pinkPurpleLight"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(headline_GetHeader, {
                                    tag: tag,
                                    title: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                    autoPlay: true,
                                    playsInline: true,
                                    loop: true,
                                    muted: true,
                                    src: media + "#t=0.001",
                                    className: "z-[1] h-[330px] rounded-[8px] object-cover tablet:hidden"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-body-2 z-[1] mt-2 tablet:mt-0",
                                    children: subtitle
                                }),
                                upload && tool !== "ai_music_generator" && /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* ConditionalAnchor */.hq, {
                                    href: branch/* appStoreConstant */.HY,
                                    className: "mt-2 block w-full desktop:hidden",
                                    children: button_text
                                }),
                                upload && dropzoneState && toolClick && formats && /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_drop_area/* SimpleDropArea */.$J, {
                                    border: true,
                                    className: "mt-5 hidden h-[230px] w-[475px] bg-blue-50 desktop:flex",
                                    state: dropzoneState,
                                    formats: formats,
                                    openExplorer: toolClick,
                                    loading: editor.loading
                                }),
                                upload && toolClick && button_text && tool !== "ai_music_generator" && !onDrop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative z-20 hidden h-[130px] w-full rounded-[14px] border border-color-separator bg-color-cell desktop:flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                    disabled: editor.loading || loading,
                                                    placeholder: t("txt_describe_imagination"),
                                                    className: (0,clsx_m/* default */.Z)("text-body-5 no-scrollbar h-[95px] w-full resize-none rounded-[14px] bg-color-cell py-2 pl-3 pr-8 placeholder:text-color-placeholder focus-visible:outline-none", loading ? "text-color-placeholder" : "text-blue-800"),
                                                    value: text,
                                                    onChange: function(e) {
                                                        var inputValue = e.currentTarget.value;
                                                        if (inputValue.length <= 1000) {
                                                            setText(inputValue);
                                                        }
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    disabled: loading,
                                                    onClick: function() {
                                                        return getMagic();
                                                    },
                                                    className: "absolute bottom-2 left-3 flex flex-row items-center gap-1 disabled:pointer-events-none",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (0,cdn/* assetUrl */.p)("/ai-tools/text-to-image/magic.svg"),
                                                            alt: "magic"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-body-5 font-500 text-primary-500",
                                                            children: "Surprise Me"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            alt: "loading",
                                                            src: (0,cdn/* assetUrl */.p)("/ai-tools/text-to-image/loading.webp"),
                                                            className: (0,clsx_m/* default */.Z)("pointer-events-none h-3 w-3 animate-spin [animation-timing-function:linear]", loading ? "opacity-100" : "opacity-0")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    onClick: function() {
                                                        setText("");
                                                    },
                                                    className: (0,clsx_m/* default */.Z)("absolute right-3 top-2 flex h-[17px] w-[17px] items-center justify-center rounded-full", "bg-blue-200 transition-all hover:bg-blue-400", text.length === 0 ? "pointer-events-none opacity-0" : "opacity-100"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                                        format: "svg",
                                                        source: "/general/close",
                                                        className: "h-[12px] w-[12px]"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute bottom-2 right-3 flex flex-row items-center gap-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-[14px] font-500 text-color-placeholder",
                                                        children: text.length + "/1000"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                            primary: true,
                                            text: button_text,
                                            onClick: function() {
                                                return toolClick(text);
                                            },
                                            className: "hidden w-full desktop:block"
                                        })
                                    ]
                                }),
                                button_text && tool === "ai_music_generator" && /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                    loading: editor.loading,
                                    primary: true,
                                    onClick: toolClick,
                                    text: button_text,
                                    className: "z-[1] mt-2 tablet:mt-4 desktop:mt-9 desktop:w-[275px]"
                                }),
                                button_text && !upload && /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                    primary: true,
                                    full: true,
                                    text: button_text,
                                    href: button_link,
                                    className: "z-[1] mt-2 tablet:mt-4 desktop:mt-9 desktop:w-[275px]"
                                }),
                                !without_qr && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlatformsSection, {
                                    platforms: acceptedPlatforms
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            playsInline: true,
                            autoPlay: true,
                            loop: true,
                            muted: true,
                            src: media + "#t=0.001",
                            className: "z-[1] hidden h-[367px] w-[293px] rounded-[14px] object-cover tablet:block desktop:h-[489px] desktop:w-[377px]"
                        })
                    ]
                })
            ]
        })
    });
}
function headline_GetHeader(props) {
    var tag = props.tag, title = props.title;
    switch(tag){
        case "h1":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-h3 z-[1] text-center tablet:text-start",
                children: title
            });
        case "h2":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-h3 z-[1] text-center tablet:text-start",
                children: title
            });
        case "h3":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-h3 z-[1] text-center tablet:text-start",
                children: title
            });
        case "h4":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "text-h3 z-[1] text-center tablet:text-start",
                children: title
            });
    }
}
function HeadlineLarge(props) {
    var image_left = props.image_left, bubble_text = props.bubble_text, button_link = props.button_link, button_text = props.button_text, tag = props.tag, title = props.title, subtitle = props.subtitle, media = props.media, without_qr = props.without_qr, platforms = props.platforms, words = props.words, title_attr = props.title_attr, left_icon = props.left_icon, right_icon = props.right_icon, className = props.className, video_thumb = props.video_thumb, logEvent = props.logEvent;
    var logAdjust = (0,adjust/* useAdjustLogger */.eW)();
    var acceptedPlatforms = platforms !== null && platforms !== void 0 ? platforms : [
        "ios",
        "android",
        "web", 
    ];
    var ref = (0,react.useState)(true), showImage = ref[0], setShowImage = ref[1];
    (0,react.useEffect)(function() {
        var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        var isWebm = media.endsWith(".webm");
        setShowImage(Boolean(isWebm && video_thumb && (isIOS || isSafari)));
    }, [
        media,
        showImage,
        video_thumb
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "flex w-full items-center justify-center px-4 tablet:px-0 desktop:px-[calc(50vw-702px)]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)("relative flex w-full flex-col items-center gap-6 tablet:w-[720px] tablet:items-center tablet:justify-between desktop:w-full desktop:px-[30px]", image_left ? "tablet:flex-row-reverse" : "tablet:flex-row", className && !showImage ? className : "py-[16px] tablet:py-[40px] desktop:py-[60px]"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full flex-col items-center gap-2 tablet:w-auto tablet:max-w-[295px] tablet:items-start desktop:max-w-[600px]",
                    children: [
                        bubble_text && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "z-[1] flex flex-row justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bubble/* default */.ZP, {
                                text: bubble_text,
                                color: "pinkPurpleLight"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GetHeader, {
                            tag: tag,
                            title: title,
                            title_attr: title_attr,
                            textStart: true,
                            children: words && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedWords, {
                                words: words
                            })
                        }),
                        !showImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            autoPlay: true,
                            playsInline: true,
                            loop: true,
                            muted: true,
                            src: media + "#t=0.001",
                            className: "z-[1] my-2 max-h-[442px] min-h-[300px] w-full rounded-[12px] object-contain tablet:hidden"
                        }),
                        showImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "z-[1] my-2 max-h-[442px] min-h-[300px] w-full object-contain px-5 tablet:hidden",
                            alt: "video thumbnail",
                            src: video_thumb
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "font z-[1] font-400 leading-[1.618] text-blue-700 tablet:mt-[20px] tablet:text-[16px] desktop:text-[18px]",
                            children: subtitle
                        }),
                        button_text && button_link && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: button_link,
                            onClick: function() {
                                if (logEvent) {
                                    logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEventWithPayload("w_dp_start_now", {
                                        from: "home",
                                        type: logEvent
                                    });
                                }
                            },
                            className: (0,clsx_m/* default */.Z)("z-[1] mt-2 flex w-full shrink-0 select-none flex-row items-center justify-center gap-2 text-[18px] font-600", "rounded-[6px] tablet:mt-4 desktop:mt-5 desktop:h-[64px] desktop:w-[280px] desktop:rounded-[10px]", "bg-primary-500 text-color-white transition-colors duration-300 ease-in-out hover:bg-primary-600", "cursor-pointer disabled:cursor-not-allowed disabled:opacity-50", "px-[34px] py-[14px]"),
                            children: [
                                left_icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: left_icon,
                                    alt: "left icon"
                                }),
                                button_text,
                                right_icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: right_icon,
                                    alt: "right icon"
                                })
                            ]
                        }),
                        !without_qr && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlatformsSection, {
                            platforms: acceptedPlatforms
                        })
                    ]
                }),
                !showImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    playsInline: true,
                    autoPlay: true,
                    loop: true,
                    muted: true,
                    src: media + "#t=0.001",
                    className: (0,clsx_m/* default */.Z)("z-[1] hidden max-h-[500px] min-h-[300px] w-[355px] rounded-[12px] object-contain tablet:block desktop:max-h-[700px] desktop:min-h-[510px] desktop:w-[45%]")
                }),
                showImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "z-[1] hidden max-h-[500px] min-h-[300px] w-[355px] object-contain tablet:block desktop:max-h-[700px] desktop:min-h-[510px] desktop:w-[45%]",
                    alt: "video thumbnail",
                    src: video_thumb
                })
            ]
        })
    });
}
function PlatformsSection(props) {
    var acceptedPlatforms = props.platforms;
    var inView = (0,react_intersection_observer/* useInView */.YD)().inView;
    var ref = (0,react.useState)(false), storeSelected = ref[0], setStoreSelected = ref[1];
    var ref1 = (0,react.useState)(false), qrSelected = ref1[0], setQrSelected = ref1[1];
    var ref2 = (0,react.useState)(true), hidden = ref2[0], setHidden = ref2[1];
    if (hidden && (storeSelected || qrSelected)) setHidden(false);
    var style = (0,display_trigger/* useBoop */.k)({
        scale: 1.3,
        trigger: storeSelected || qrSelected,
        close: function() {
            setHidden(true);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(breakpoints/* Desktop */.Hi, {
                className: "flex flex-row gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floating/* Relative */.I, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_styled_flex_esm/* FlexBox */.hs, {
                            alignItems: "stretch",
                            margin: "24px -8px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* FlexBox */.hs, {
                                    onMouseOver: function() {
                                        return setStoreSelected(true);
                                    },
                                    onMouseLeave: function() {
                                        return setStoreSelected(false);
                                    },
                                    children: acceptedPlatforms.map(function(platform) {
                                        switch(platform){
                                            case "android":
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GooglePlayIcon, {}, platform);
                                            case "ios":
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppStoreIcon, {}, platform);
                                            case "web":
                                                return;
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(floating/* default */.Z, {
                                    position: {
                                        top: inView ? -265 : 110,
                                        left: 0
                                    },
                                    z: 13,
                                    none: hidden,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* FlexBox */.hs, {
                                        center: true,
                                        width: "100%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_modern/* animated.div */.q.div, {
                                            style: style,
                                            onMouseOver: function() {
                                                return storeSelected && setQrSelected(true);
                                            },
                                            onMouseLeave: function() {
                                                return setQrSelected(false);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(qr/* default */.Z, {})
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    acceptedPlatforms.filter(function(platform) {
                        return platform === "web";
                    }).map(function(platform) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " my-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopIcon, {})
                        }, platform);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Tablet */.YD, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_styled_flex_esm/* FlexBox */.hs, {
                    alignItems: "stretch",
                    margin: "16px -8px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoresContainer, {
                        children: acceptedPlatforms.map(function(platform) {
                            switch(platform){
                                case "android":
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GooglePlayIcon, {}, platform);
                                case "ios":
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppStoreIcon, {}, platform);
                                case "web":
                                    return;
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Mobile */.ij, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_styled_flex_esm/* FlexBox */.hs, {
                    maxWidth: "1175px",
                    width: "var(--w-screen)",
                    alignItems: "stretch",
                    margin: "12px 0px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StoresContainer, {
                            children: acceptedPlatforms.map(function(platform) {
                                switch(platform){
                                    case "android":
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GooglePlayIcon, {}, platform);
                                    case "ios":
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppStoreIcon, {}, platform);
                                    case "web":
                                        return;
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, {})
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./pages/tools/index.tsx
var tools = __webpack_require__(9274);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var src_sliced_to_array = __webpack_require__(253);
// EXTERNAL MODULE: ./utils/video.tsx
var utils_video = __webpack_require__(6961);
;// CONCATENATED MODULE: ./comps/before-after.tsx







var BeforeAfterHold = function(props) {
    var source = props.source, initialPercent = props.initialPercent, labels = props.labels, video = props.video, className = props.className;
    var ref = useState(initialPercent !== null && initialPercent !== void 0 ? initialPercent : 50), position = ref[0], setPosition = ref[1];
    var ref1 = useState(false), pressed = ref1[0], setPressed = ref1[1];
    var t = useTranslation().t;
    var ref2 = useState(null), loadedVideos = ref2[0], setLoadedVideos = ref2[1];
    useEffect(function() {
        if (!video) {
            return;
        }
        Promise.all([
            loadUrlToBlob(assetUrl("/tools/".concat(source, "-before.mp4"))),
            loadUrlToBlob(assetUrl("/tools/".concat(source, "-after.mp4"))), 
        ]).then(function(param) {
            var _param = _sliced_to_array(param, 2), before = _param[0], after = _param[1];
            setLoadedVideos({
                before: URL.createObjectURL(before),
                after: URL.createObjectURL(after)
            });
        }).catch(console.error);
    }, [
        video,
        source
    ]);
    var labelClasses = "absolute bottom-4 px-[24px] py-[6px] pointer-events-none bg-color-black/40 rounded-full uppercase text-color-white font-600";
    var beforeClasses = "absolute h-full w-full top-0 left-0 pointer-events-none object-cover object-left inset-0";
    return /*#__PURE__*/ _jsxs("div", {
        className: clsx("relative cursor-ew-resize", className),
        onPointerDown: function() {
            return setPressed(true);
        },
        onPointerLeave: function() {
            return setPressed(false);
        },
        onPointerUp: function() {
            return setPressed(false);
        },
        onPointerMove: function(event) {
            if (!pressed) {
                return;
            }
            var ref = event.currentTarget.getBoundingClientRect(), x = ref.x, width = ref.width;
            var ratio = (event.clientX - x) / width;
            setPosition(ratio * 100);
        },
        children: [
            video ? loadedVideos ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("video", {
                        autoPlay: true,
                        playsInline: true,
                        loop: true,
                        muted: true,
                        style: {
                            width: position + "%"
                        },
                        className: beforeClasses,
                        src: loadedVideos.before
                    }),
                    /*#__PURE__*/ _jsx("video", {
                        autoPlay: true,
                        playsInline: true,
                        loop: true,
                        muted: true,
                        className: "pointer-events-none h-full w-full object-cover object-left",
                        src: loadedVideos.after
                    })
                ]
            }) : /*#__PURE__*/ _jsx("img", {
                src: assetUrl("/tools/".concat(source, "-thumbnail.webp")),
                alt: "skeleton"
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        src: assetUrl("/tools/".concat(source, "-before.webp")),
                        alt: "before",
                        style: {
                            width: position + "%"
                        },
                        className: beforeClasses
                    }),
                    /*#__PURE__*/ _jsx("img", {
                        src: assetUrl("/tools/".concat(source, "-after.webp")),
                        alt: "after",
                        className: "pointer-events-none h-full w-full object-cover object-left"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "pointer-events-none absolute top-0 z-50 flex h-full w-[42px] flex-col items-center",
                style: {
                    left: "calc(".concat(position, "% - 21px)")
                },
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "w-1 flex-1 bg-color-white"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex h-[42px] w-[42px] items-center justify-center rounded-full border-4 border-color-white backdrop-blur",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "26",
                            height: "12",
                            viewBox: "0 0 26 12",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M19 1L24.0781 5.23178C24.5579 5.63157 24.5579 6.36843 24.0781 6.76822L19 11",
                                    stroke: "white",
                                    strokeWidth: "2",
                                    strokeLinecap: "round"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M7 1L1.92186 5.23178C1.44211 5.63157 1.44211 6.36843 1.92187 6.76822L7 11",
                                    stroke: "white",
                                    strokeWidth: "2",
                                    strokeLinecap: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "w-1 flex-1 bg-color-white"
                    })
                ]
            }),
            labels && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: clsx("left-4", labelClasses),
                        children: t("lbl_before")
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: clsx("right-4", labelClasses),
                        children: t("lbl_after")
                    })
                ]
            })
        ]
    });
};
var BeforeAfter = function(props) {
    var source = props.source, initialPercent = props.initialPercent, labels = props.labels, video = props.video, className = props.className;
    var ref = useState(initialPercent !== null && initialPercent !== void 0 ? initialPercent : 50), position = ref[0], setPosition = ref[1];
    var t = useTranslation().t;
    var ref1 = useState(null), loadedVideos = ref1[0], setLoadedVideos = ref1[1];
    useEffect(function() {
        if (!video) {
            return;
        }
        Promise.all([
            loadUrlToBlob(assetUrl("/tools/".concat(source, "-before.mp4"))),
            loadUrlToBlob(assetUrl("/tools/".concat(source, "-after.mp4"))), 
        ]).then(function(param) {
            var _param = _sliced_to_array(param, 2), before = _param[0], after = _param[1];
            setLoadedVideos({
                before: URL.createObjectURL(before),
                after: URL.createObjectURL(after)
            });
        }).catch(console.error);
    }, [
        video,
        source
    ]);
    var labelClasses = "absolute bottom-[10px] text-[14px] desktop:px-[20px] desktop:py-[8px] pointer-events-none bg-color-black/40 px-3 py-1 rounded-full uppercase text-color-white font-600";
    var beforeClasses = "absolute h-full w-full top-0 left-0 pointer-events-none object-cover object-left inset-0";
    return /*#__PURE__*/ _jsxs("div", {
        className: clsx("relative cursor-ew-resize", className),
        onPointerMove: function(event) {
            var ref = event.currentTarget.getBoundingClientRect(), x = ref.x, width = ref.width;
            var ratio = (event.clientX - x) / width;
            setPosition(ratio * 100);
        },
        children: [
            video ? loadedVideos ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("video", {
                        autoPlay: true,
                        playsInline: true,
                        loop: true,
                        muted: true,
                        style: {
                            width: position + "%"
                        },
                        className: beforeClasses,
                        src: loadedVideos.before
                    }),
                    /*#__PURE__*/ _jsx("video", {
                        autoPlay: true,
                        playsInline: true,
                        loop: true,
                        muted: true,
                        className: "pointer-events-none h-full w-full object-cover object-left",
                        src: loadedVideos.after
                    })
                ]
            }) : /*#__PURE__*/ _jsx("img", {
                src: assetUrl("/tools/".concat(source, "-thumbnail.webp")),
                alt: "skeleton"
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        src: assetUrl("/tools/".concat(source, "-before.webp")),
                        alt: "before",
                        style: {
                            width: position + "%"
                        },
                        className: beforeClasses
                    }),
                    /*#__PURE__*/ _jsx("img", {
                        src: assetUrl("/tools/".concat(source, "-after.webp")),
                        alt: "after",
                        className: "pointer-events-none h-full w-full object-cover object-left"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "pointer-events-none absolute top-0 z-50 flex h-full w-[42px] flex-col items-center",
                style: {
                    left: "calc(".concat(position, "% - 21px)")
                },
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "w-1 flex-1 bg-color-white"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex h-[42px] w-[42px] items-center justify-center rounded-full border-4 border-color-white backdrop-blur",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "26",
                            height: "12",
                            viewBox: "0 0 26 12",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M19 1L24.0781 5.23178C24.5579 5.63157 24.5579 6.36843 24.0781 6.76822L19 11",
                                    stroke: "white",
                                    strokeWidth: "2",
                                    strokeLinecap: "round"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M7 1L1.92186 5.23178C1.44211 5.63157 1.44211 6.36843 1.92187 6.76822L7 11",
                                    stroke: "white",
                                    strokeWidth: "2",
                                    strokeLinecap: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "w-1 flex-1 bg-color-white"
                    })
                ]
            }),
            labels && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: clsx("left-[10px]", labelClasses),
                        children: t("lbl_before")
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: clsx("right-[10px]", labelClasses),
                        children: t("lbl_after")
                    })
                ]
            })
        ]
    });
};
var BeforeAfterWithSmallCircle = function(props) {
    var before = props.before, after = props.after, initialPercent = props.initialPercent, video = props.video, className = props.className, labels = props.labels;
    var ref = (0,react.useState)(initialPercent !== null && initialPercent !== void 0 ? initialPercent : 50), position = ref[0], setPosition = ref[1];
    var ref1 = (0,react.useState)(null), loadedVideos = ref1[0], setLoadedVideos = ref1[1];
    (0,react.useEffect)(function() {
        if (!video) {
            return;
        }
        Promise.all([
            (0,utils_video/* loadUrlToBlob */.fj)(before),
            (0,utils_video/* loadUrlToBlob */.fj)(after), 
        ]).then(function(param) {
            var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), before = _param[0], after = _param[1];
            setLoadedVideos({
                before: URL.createObjectURL(before),
                after: URL.createObjectURL(after)
            });
        }).catch(console.error);
    }, [
        video,
        before,
        after
    ]);
    var labelClasses = "absolute bottom-[10px] text-[14px] desktop:px-[20px] desktop:py-[8px] pointer-events-none bg-color-black/40 px-3 py-1 rounded-full uppercase text-color-white font-600";
    var beforeClasses = "absolute h-full w-full top-0 left-0 pointer-events-none object-cover object-left inset-0";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("relative cursor-ew-resize", className),
        onPointerMove: function(event) {
            var ref = event.currentTarget.getBoundingClientRect(), x = ref.x, width = ref.width;
            var ratio = (event.clientX - x) / width;
            setPosition(ratio * 100);
        },
        children: [
            video ? loadedVideos ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        autoPlay: true,
                        playsInline: true,
                        loop: true,
                        muted: true,
                        style: {
                            width: position + "%"
                        },
                        className: beforeClasses,
                        src: loadedVideos.before
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        autoPlay: true,
                        playsInline: true,
                        loop: true,
                        muted: true,
                        className: "pointer-events-none h-full w-full object-cover object-left",
                        src: loadedVideos.after
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                autoPlay: true,
                playsInline: true,
                loop: true,
                muted: true,
                src: after,
                className: "pointer-events-none h-full w-full object-cover object-left"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: before,
                        alt: "before",
                        style: {
                            width: position + "%"
                        },
                        className: beforeClasses
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: after,
                        alt: "after",
                        className: "pointer-events-none h-full w-full object-cover object-left"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pointer-events-none absolute top-0 z-50 flex h-full w-[42px] flex-col items-center",
                style: {
                    left: "calc(".concat(position, "% - 21px)")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1 flex-1 bg-color-white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex h-[21px] w-[21px] items-center justify-center rounded-full border-color-white bg-color-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            width: "13",
                            height: "7",
                            viewBox: "0 0 13 7",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M3.61252 1L1.33926 3.27326C1.14272 3.46979 1.14272 3.78845 1.33926 3.98499L3.61252 6.25824",
                                    stroke: "#212127",
                                    strokeWidth: "1.00654",
                                    strokeLinecap: "round"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M9.65176 1L11.925 3.27326C12.1216 3.46979 12.1216 3.78845 11.925 3.98499L9.65176 6.25824",
                                    stroke: "#212127",
                                    strokeWidth: "1.00654",
                                    strokeLinecap: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1 flex-1 bg-color-white"
                    })
                ]
            }),
            labels && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (0,clsx_m/* default */.Z)("left-[10px]", labelClasses),
                        children: "Before"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (0,clsx_m/* default */.Z)("right-[10px]", labelClasses),
                        children: "After"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var before_after = ((/* unused pure expression or super */ null && (BeforeAfter)));

;// CONCATENATED MODULE: ./comps/feature/how-to-make.tsx












var how_to_make_featureAiToolSchema = lib.z["enum"]([
    "deform",
    "ai_photo",
    "ai_restyle",
    "text_to_image",
    "text_to_video",
    "ai_music_generator", 
]);
var stepSchema = lib.z.object({
    title: lib.z.string(),
    description: lib.z.string()
});
var tutorialSchema = lib.z.object({
    component: lib.z.literal("how_to_make"),
    title: lib.z.string(),
    subtitle: lib.z.string().optional(),
    button_text: lib.z.string(),
    button_link: lib.z.string().optional(),
    steps: lib.z.array(stepSchema),
    media: lib.z.string().optional(),
    before: lib.z.string().optional(),
    after: lib.z.string().optional(),
    is_video: lib.z.boolean().optional(),
    image_alt: lib.z.string().optional(),
    style: lib.z.literal("large").optional(),
    title_attr: lib.z.array(lib.z.object({
        start: lib.z.number(),
        length: lib.z.number(),
        color: lib.z.string().optional(),
        dark_color: lib.z.string().optional()
    })).optional(),
    upload: lib.z.boolean().optional(),
    tool: how_to_make_featureAiToolSchema.optional()
});
function HowToMake(props) {
    var calculateHeight = function calculateHeight(text, index, lineLength, lineHeight) {
        if (stepNumber === index) {
            var height = text.split("\n").filter(function(temp) {
                return temp.length !== 0;
            }).reduce(function(prev, cur) {
                return prev + Math.ceil(cur.length / lineLength) * lineHeight;
            }, 0);
            height = height + ((text.split("\n\n") || []).length - 1) * lineHeight;
            return "".concat(height, "px");
        } else {
            return "0px";
        }
    };
    var ref = (0,react.useState)(0), stepNumber = ref[0], setStepNumber = ref[1];
    var title = props.title, button_text = props.button_text, button_link = props.button_link, steps = props.steps, subtitle = props.subtitle, media = props.media, before = props.before, after = props.after, is_video = props.is_video, upload = props.upload, tool = props.tool, image_alt = props.image_alt, style = props.style;
    var onClick = (0,editor_editor/* useUploadOption */.Y4)(upload, tool).onClick;
    var editor = (0,editor_editor/* useEditorParamsContext */.mK)();
    if (style && style === "large") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HowToMakeLarge, (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex w-full justify-center py-[16px] tablet:py-[40px] desktop:py-[55px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "atablet:overflow-hidden flex w-full flex-col items-center gap-1 tablet:w-[727px] desktop:w-[975px] desktop:px-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center gap-4 text-center desktop:gap-[22px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-h2 tablet:text-h3 whitespace-pre-line px-4 text-center",
                                children: title
                            }),
                            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-body-3 px-4 text-center text-blue-700 tablet:px-16",
                                children: subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full flex-col items-center gap-9 tablet:flex-row",
                        children: [
                            !is_video && media && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: media,
                                alt: image_alt !== null && image_alt !== void 0 ? image_alt : title,
                                className: "pointer-events-none w-full shrink-0 rounded-[20px] object-contain tablet:h-[329px] tablet:w-[231px] desktop:h-[437px] desktop:w-[355px] desktop:rounded-2xl"
                            }),
                            is_video && media && /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                autoPlay: true,
                                playsInline: true,
                                loop: true,
                                muted: true,
                                src: media,
                                className: "pointer-events-none w-[300px] shrink-0 rounded-[8px] object-cover tablet:h-[329px] tablet:w-[231px] desktop:h-[437px] desktop:w-[355px] desktop:rounded-[14px]"
                            }),
                            before && after && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ah-[352px] atablet:h-[329px] adesktop:h-[437px] relative w-[281px] shrink-0 overflow-hidden rounded-[20px] tablet:w-[231px] desktop:w-[355px] desktop:rounded-2xl",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BeforeAfterWithSmallCircle, {
                                    before: before,
                                    after: after,
                                    video: is_video,
                                    className: "w-full",
                                    labels: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex w-full flex-col items-center justify-between gap-3 tablet:h-full tablet:items-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex w-full flex-col gap-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "pointer-events-none absolute left-0 top-0 hidden h-[50px] w-full bg-gradient-to-b from-color-cell to-[#F9F9FE00] tablet:block"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "no-scrollbar flex w-full flex-row gap-3 overflow-x-scroll px-4 tablet:h-[257px] tablet:flex-col tablet:overflow-y-scroll tablet:px-0 tablet:py-11 desktop:h-[365px]",
                                                        children: steps.map(function(step, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "shrink-0",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "hidden flex-col gap-2 tablet:flex",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                                onClick: function() {
                                                                                    setStepNumber(index);
                                                                                },
                                                                                className: "flex flex-row items-center gap-4",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "flex flex-row items-center",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bubble/* default */.ZP, {
                                                                                            className: "flex !h-[26px] !w-[26px] items-center justify-center !p-0",
                                                                                            text: String(index + 1),
                                                                                            color: stepNumber === index || step.description.trim().length === 0 ? "purplePinkSelected" : "purplePink"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "flex flex-row items-center gap-[6px]",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                className: (0,clsx_m/* default */.Z)(stepNumber === index || step.description.trim().length === 0 ? "text-body-2" : "text-body-3 text-blue-600"),
                                                                                                children: step.title
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: (0,clsx_m/* default */.Z)("transition-all", stepNumber === index ? "-rotate-90 [--icon-color:var(--color-blue-800)]" : "rotate-90 [--icon-color:var(--color-blue-600)]", step.description.trim().length === 0 && "hidden"),
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tools.Arrow, {})
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                style: {
                                                                                    whiteSpace: "pre-line",
                                                                                    "--desktop-size": calculateHeight(step.description, index, 65, 27),
                                                                                    "--tablet-size": calculateHeight(step.description, index, 55, 24)
                                                                                },
                                                                                className: "text-body-4 hidden overflow-hidden pl-[42px] transition-all duration-500 tablet:block tablet:max-h-[var(--tablet-size)] desktop:max-h-[var(--desktop-size)]",
                                                                                children: step.description
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        onClick: function() {
                                                                            return setStepNumber(index);
                                                                        },
                                                                        className: "flex shrink-0 tablet:hidden",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bubble/* default */.ZP, {
                                                                            text: "Step " + (index + 1),
                                                                            color: stepNumber === index ? "purplePinkSelected" : "purplePinkWithHover"
                                                                        })
                                                                    }, index)
                                                                ]
                                                            }, index);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "pointer-events-none absolute bottom-0 left-0 hidden h-[46px] w-full bg-gradient-to-t from-color-cell to-[#F9F9FE00] tablet:block"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-body-2 mt-4 block px-4 tablet:mt-3 tablet:hidden",
                                                children: steps[stepNumber].title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                style: {
                                                    whiteSpace: "pre-line"
                                                },
                                                className: "text-body-4 block px-4 tablet:hidden",
                                                children: steps[stepNumber].description
                                            })
                                        ]
                                    }),
                                    button_text && tool !== "ai_music_generator" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                                href: button_link,
                                                onClick: function() {
                                                    onClick && onClick();
                                                },
                                                loading: editor.loading,
                                                className: "mt-8 hidden tablet:mt-0 desktop:block",
                                                text: button_text,
                                                primary: true,
                                                full: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                                href: branch/* appStoreConstant */.HY,
                                                text: button_text,
                                                primary: true,
                                                full: true,
                                                className: "mt-2 w-full tablet:mt-0 desktop:hidden"
                                            })
                                        ]
                                    }),
                                    button_text && tool === "ai_music_generator" && /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                        loading: editor.loading,
                                        primary: true,
                                        full: true,
                                        onClick: onClick,
                                        text: button_text,
                                        className: "mt-8 tablet:mt-0"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function HowToMakeLarge(props) {
    var calculateHeight = function calculateHeight(text, index, lineLength, lineHeight) {
        if (stepNumber === index) {
            var height = text.split("\n").filter(function(temp) {
                return temp.length !== 0;
            }).reduce(function(prev, cur) {
                return prev + Math.ceil(cur.length / lineLength) * lineHeight;
            }, 0);
            height = height + ((text.split("\n\n") || []).length - 1) * lineHeight;
            return "".concat(height, "px");
        } else {
            return "0px";
        }
    };
    var ref = (0,react.useState)(0), stepNumber = ref[0], setStepNumber = ref[1];
    var title = props.title, button_text = props.button_text, button_link = props.button_link, steps = props.steps, subtitle = props.subtitle, media = props.media, before = props.before, after = props.after, is_video = props.is_video, upload = props.upload, tool = props.tool, image_alt = props.image_alt, title_attr = props.title_attr;
    var resolvedTheme = (0,index_module/* useTheme */.F)().resolvedTheme;
    var onClick = (0,editor_editor/* useUploadOption */.Y4)(upload, tool).onClick;
    var editor = (0,editor_editor/* useEditorParamsContext */.mK)();
    var formattedTitle = title;
    if (title_attr) {
        var _loop = function(i) {
            var isColored = title_attr.some(function(param) {
                var start = param.start, length = param.length;
                return i >= start && i < start + length;
            });
            var attr = title_attr.find(function(param) {
                var start = param.start, length = param.length;
                return i >= start && i < start + length;
            });
            var color = "var(--color-primary-500)";
            if (attr && resolvedTheme === "dark" && attr.dark_color) {
                color = attr.dark_color;
            } else if (attr && attr.color) {
                color = attr.color;
            }
            if (isColored) {
                formattedTitle.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        color: color
                    },
                    className: "text-[30px] font-700 desktop:text-[54px]",
                    children: title[i]
                }, index));
            } else {
                formattedTitle.push(title[i]);
            }
            index++;
        };
        formattedTitle = [];
        var index = 0;
        for(var i = 0; i < title.length; i++)_loop(i);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "flex w-full items-center justify-center px-4 py-[35px] tablet:px-0 tablet:py-[40px] desktop:px-[calc(50vw-702px)] desktop:py-[100px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full flex-col items-center gap-4 tablet:w-[727px] desktop:w-full desktop:gap-9 desktop:px-[30px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center gap-4 text-center desktop:gap-[22px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "whitespace-pre-line px-4 text-center text-[30px] font-700 desktop:text-[54px]",
                            children: formattedTitle
                        }),
                        subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-body-3 px-4 text-center text-blue-700 tablet:px-16",
                            children: subtitle
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full flex-col items-center gap-9 tablet:flex-row desktop:justify-between",
                    children: [
                        !is_video && media && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: media,
                            alt: image_alt !== null && image_alt !== void 0 ? image_alt : title,
                            className: "pointer-events-none max-h-[352px] w-[281px] shrink-0 rounded-[12px] object-contain tablet:max-h-[600px] tablet:w-[355px] desktop:max-h-[700px] desktop:w-[660px]"
                        }),
                        is_video && media && /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            autoPlay: true,
                            playsInline: true,
                            loop: true,
                            muted: true,
                            src: media,
                            className: "pointer-events-none max-h-[352px] w-[281px] shrink-0 rounded-[12px] object-cover tablet:max-h-[329px] tablet:w-[231px] desktop:max-h-[700px] desktop:w-[660px]"
                        }),
                        before && after && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative w-[281px] shrink-0 overflow-hidden rounded-[12px] tablet:w-[231px] desktop:w-[660px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BeforeAfterWithSmallCircle, {
                                before: before,
                                after: after,
                                video: is_video,
                                className: "w-full",
                                labels: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-full flex-col items-center justify-between gap-3 tablet:h-full tablet:w-auto tablet:max-w-[355px] tablet:items-start desktop:w-auto desktop:max-w-[542px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex w-full flex-col gap-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "pointer-events-none absolute left-0 top-0 hidden h-[50px] w-full bg-gradient-to-b from-color-cell to-[#F9F9FE00] tablet:block"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "no-scrollbar flex w-full flex-row gap-3 overflow-x-scroll tablet:h-[257px] tablet:flex-col tablet:overflow-y-scroll tablet:px-0 tablet:py-11 desktop:h-[365px]",
                                                    children: steps.map(function(step, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "shrink-0",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "hidden flex-col gap-2 tablet:flex",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                            onClick: function() {
                                                                                setStepNumber(index);
                                                                            },
                                                                            className: "flex flex-row items-center gap-4",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "flex flex-row items-center",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bubble/* default */.ZP, {
                                                                                        className: "flex !h-[26px] !w-[26px] items-center justify-center !p-0",
                                                                                        text: String(index + 1),
                                                                                        color: stepNumber === index || step.description.trim().length === 0 ? "purplePinkSelected" : "purplePink"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "flex flex-row items-center gap-[6px]",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            className: (0,clsx_m/* default */.Z)(stepNumber === index || step.description.trim().length === 0 ? "text-[18px] font-500 text-blue-900 tablet:text-[20px] desktop:text-[26px] desktop:font-600" : "text-[18px] font-500 text-blue-600 desktop:text-[26px] desktop:font-600"),
                                                                                            children: step.title
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: (0,clsx_m/* default */.Z)("transition-all", stepNumber === index ? "-rotate-90 [--icon-color:var(--color-blue-800)]" : "rotate-90 [--icon-color:var(--color-blue-600)]", step.description.trim().length === 0 && "hidden"),
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tools.Arrow, {})
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            style: {
                                                                                whiteSpace: "pre-line",
                                                                                "--desktop-size": calculateHeight(step.description, index, 65, 27),
                                                                                "--tablet-size": calculateHeight(step.description, index, 55, 24)
                                                                            },
                                                                            className: "text-body-4 hidden overflow-hidden pl-[42px] text-blue-700 transition-all duration-500 tablet:block tablet:max-h-[var(--tablet-size)] desktop:max-h-[var(--desktop-size)]",
                                                                            children: step.description
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                    onClick: function() {
                                                                        return setStepNumber(index);
                                                                    },
                                                                    className: "flex shrink-0 tablet:hidden",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bubble/* default */.ZP, {
                                                                        text: "Step " + (index + 1),
                                                                        color: stepNumber === index ? "purplePinkSelected" : "purplePinkWithHover"
                                                                    })
                                                                }, index)
                                                            ]
                                                        }, index);
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "pointer-events-none absolute bottom-0 left-0 hidden h-[46px] w-full bg-gradient-to-t from-color-cell to-[#F9F9FE00] tablet:block"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-body-2 mt-4 block tablet:mt-3 tablet:hidden",
                                            children: steps[stepNumber].title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            style: {
                                                whiteSpace: "pre-line"
                                            },
                                            className: "text-body-4 block tablet:hidden",
                                            children: steps[stepNumber].description
                                        })
                                    ]
                                }),
                                button_text && button_link && /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                    text: button_text,
                                    href: button_link,
                                    primary: true,
                                    full: true,
                                    className: "mt-8"
                                }),
                                button_text && !button_link && tool !== "ai_music_generator" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                            onClick: function() {
                                                onClick && onClick();
                                            },
                                            loading: editor.loading,
                                            className: "mt-8 hidden tablet:mt-0 desktop:block",
                                            text: button_text,
                                            primary: true,
                                            full: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                            href: branch/* appStoreConstant */.HY,
                                            text: button_text,
                                            primary: true,
                                            full: true,
                                            className: "mt-8 w-full tablet:mt-0 desktop:hidden"
                                        })
                                    ]
                                }),
                                button_text && tool === "ai_music_generator" && /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                    loading: editor.loading,
                                    primary: true,
                                    full: true,
                                    onClick: onClick,
                                    text: button_text,
                                    className: "mt-8 tablet:mt-0"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./comps/feature/info-button.tsx



var infoButtonSchema = lib.z.object({
    component: lib.z.literal("info-button"),
    image: lib.z.string(),
    title: lib.z.string(),
    subtitle: lib.z.string(),
    left: lib.z.boolean().default(false),
    button_text: lib.z.string(),
    button_link: lib.z.string().default("/chat")
});
function InfoButton(props) {
    var image = props.image, title = props.title, subtitle = props.subtitle, left = props.left, button_link = props.button_link, button_text = props.button_text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex w-full justify-center py-[60px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)(left ? "desktop:flex-row" : "desktop:flex-row-reverse", "flex flex-col items-center desktop:w-[606px] desktop:justify-between"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center gap-[22px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: (0,clsx_m/* default */.Z)("w-[232px] text-center text-[24px] font-700 text-color-black", "whitespace-pre-line desktop:w-[295px] desktop:text-start"),
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "h-[325px] w-[236px] rounded-[9px] desktop:hidden",
                            alt: "info icon",
                            src: image
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (0,clsx_m/* default */.Z)("w-[343px] text-center text-[18px] font-400 text-blue-700", "desktop:w-[295px] desktop:text-start"),
                            children: subtitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: button_link,
                            className: (0,clsx_m/* default */.Z)("mt-[18px] flex items-center justify-center gap-[8px]", "h-[44px] w-full rounded-[12px] text-[16px] font-600 disabled:pointer-events-none", "bg-primary-500 text-color-white disabled:opacity-40", "select-none transition-colors hover:bg-primary-600"),
                            children: button_text
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: image,
                    alt: "image",
                    className: "hidden h-[325px] w-[236px] rounded-[7px] desktop:flex"
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./comps/feature/info-left-right.tsx



var infoLeftRightSchema = lib.z.object({
    component: lib.z.literal("info-left-right"),
    image: lib.z.string(),
    title: lib.z.string(),
    subtitle: lib.z.string(),
    left: lib.z.boolean().default(false)
});
function InfoLeftRight(props) {
    var image = props.image, title = props.title, subtitle = props.subtitle, left = props.left;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex w-full justify-center py-[60px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)(left ? "desktop:flex-row" : "desktop:flex-row-reverse", "flex flex-col items-center desktop:w-[606px] desktop:justify-between"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center gap-[22px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: (0,clsx_m/* default */.Z)("w-[232px] text-center text-[24px] font-700 text-color-black", "desktop:w-[295px] desktop:text-start whitespace-pre-line"),
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "h-[152px] w-[285px] rounded-[9px] desktop:hidden",
                            alt: "info lefit",
                            src: image
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (0,clsx_m/* default */.Z)("w-[339px] text-center text-[18px] font-400 text-blue-700", "desktop:w-[295px] desktop:text-start"),
                            children: subtitle
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: image,
                    alt: "image",
                    className: "hidden h-[144px] w-[270px] rounded-[7px] desktop:flex"
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./comps/feature/intro.tsx



var introSchema = lib.z.object({
    component: lib.z.literal("intro"),
    title: lib.z.string(),
    subtitle: lib.z.string()
});
function IntroLanding(props) {
    var title = props.title, subtitle = props.subtitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative flex w-full justify-center pb-[35px] tablet:pb-[40px] desktop:pb-[55px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pointer-events-none absolute left-0 top-0 w-full overflow-hidden px-4 tablet:-translate-y-[70px] desktop:left-[calc(50%-588px)] desktop:w-[1175px] desktop:px-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* ResponsiveImage */.t3, {
                        src: "/ai-tools/index/intro",
                        className: "w-full desktop:w-[1175px]"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative mb-[35px] mt-[170px] flex w-full flex-col items-center justify-start tablet:mb-[40px] tablet:mt-[215px] desktop:mb-[55px] desktop:mt-[320px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "z-10 flex w-full flex-col items-center justify-start gap-4 desktop:w-[1175px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-h2 text-center",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-body-2 tablet:max-w-[380px]a desktop:max-w-[448px]a text-center",
                                children: subtitle
                            })
                        ]
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./comps/feature/reviews.tsx
var reviews = __webpack_require__(7544);
;// CONCATENATED MODULE: ./comps/feature/styles.tsx





var styles_featureAiToolSchema = lib.z["enum"]([
    "deform",
    "ai_photo",
    "ai_restyle",
    "text_to_image",
    "text_to_video",
    "ai_music_generator", 
]);
var styleSchema = lib.z.object({
    component: lib.z.literal("styles"),
    title: lib.z.string(),
    text: lib.z.string(),
    button_text: lib.z.string(),
    button_link: lib.z.string().optional(),
    media_light: lib.z.string(),
    media_dark: lib.z.string(),
    alt: lib.z.string().optional(),
    upload: lib.z.boolean().optional(),
    tool: styles_featureAiToolSchema.optional()
});
function Styles(props) {
    var title = props.title, text = props.text, button_text = props.button_text, button_link = props.button_link, media_dark = props.media_dark, media_light = props.media_light, upload = props.upload, tool = props.tool, alt = props.alt;
    var onClick = (0,editor_editor/* useUploadOption */.Y4)(upload, tool).onClick;
    var editor = (0,editor_editor/* useEditorParamsContext */.mK)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "z-20 w-full px-4 py-[16px] tablet:flex tablet:justify-center tablet:py-[40px] desktop:justify-center desktop:py-[55px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full flex-col items-center gap-5 rounded-[14px] bg-color-background px-5 py-9 tablet:w-[729px] tablet:gap-10 tablet:pl-8 desktop:w-[1175px] desktop:flex-row desktop:justify-between desktop:rounded-[20px] desktop:pl-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full flex-col items-center gap-5 tablet:gap-10 desktop:w-[642px] desktop:items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-center gap-5 tablet:px-11 desktop:items-start desktop:px-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "desktop:text-h5 text-h2 text-center desktop:text-start",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: media_light,
                                        alt: alt,
                                        className: "dark:hidden desktop:hidden"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: media_dark,
                                        alt: alt,
                                        className: "hidden dark:block dark:desktop:hidden"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-body-3 px-3 text-center tablet:px-0 desktop:text-start",
                                        children: text
                                    })
                                ]
                            }),
                            tool !== "ai_music_generator" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                        href: button_link,
                                        onClick: function() {
                                            onClick && onClick();
                                        },
                                        loading: editor.loading,
                                        className: "hidden w-full tablet:w-[50%] desktop:block desktop:w-[50%]",
                                        text: button_text,
                                        primary: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* ConditionalAnchor */.hq, {
                                        href: branch/* appStoreConstant */.HY,
                                        className: "w-full tablet:w-[50%] desktop:hidden",
                                        children: button_text
                                    })
                                ]
                            }),
                            button_text && tool === "ai_music_generator" && /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                loading: editor.loading,
                                primary: true,
                                onClick: onClick,
                                text: button_text,
                                className: "w-full tablet:w-[50%]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: media_light,
                        alt: alt,
                        className: "hidden dark:hidden tablet:max-w-[300px] desktop:block desktop:max-h-[546px] desktop:max-w-[500px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: media_dark,
                        alt: alt,
                        className: "hidden tablet:max-w-[300px] desktop:max-h-[546px] desktop:max-w-[500px] dark:desktop:block"
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./comps/feature/suggested-styles.tsx




var suggested_styles_featureAiToolSchema = lib.z["enum"]([
    "deform",
    "ai_photo",
    "ai_restyle",
    "text_to_image",
    "text_to_video",
    "ai_music_generator", 
]);
var SCROLL_SPEED = 0.8;
function ImageWithLabel(props) {
    var source = props.source, label = props.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("relative w-[135px] tablet:w-[182px]", "shrink-0", "group"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: label,
                src: source,
                className: (0,clsx_m/* default */.Z)("pointer-events-none aspect-[1] w-full rounded-[16px] object-cover")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("absolute bottom-0 left-0 flex justify-center tablet:justify-start", "p-2 desktop:translate-y-10 desktop:p-4 desktop:opacity-0 desktop:group-hover:translate-y-0 desktop:group-hover:opacity-100", "transition-all duration-300"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "rounded-[8px] bg-color-white/70 px-2 text-[14px] font-600 text-[#121212] desktop:px-5 desktop:py-1",
                    children: label
                })
            })
        ]
    });
}
var suggestedStyleSchema = lib.z.object({
    component: lib.z.literal("suggested-styles"),
    title: lib.z.string(),
    subtitle: lib.z.string().optional(),
    button_text: lib.z.string().optional(),
    button_link: lib.z.string().optional(),
    labels: lib.z.array(lib.z.object({
        name: lib.z.string(),
        thumb: lib.z.string()
    })),
    upload: lib.z.boolean().optional(),
    tool: suggested_styles_featureAiToolSchema.optional()
});
function StylesSection(props) {
    var labels = props.labels, title = props.title, subtitle = props.subtitle;
    var samplesRef = (0,react.useRef)(null);
    // const { onClick } = useUploadOption(upload, tool)
    // const editor = useEditorParamsContext()
    (0,react.useEffect)(function() {
        var handleWheel = function handleWheel(event) {
            if (!element) {
                return;
            }
            var isAtRightEdge = element.scrollLeft + element.clientWidth >= element.scrollWidth;
            var isAtLeftEdge = element.scrollLeft === 0;
            if (isAtRightEdge && event.deltaY > 0) {
                return;
            }
            if (isAtLeftEdge && event.deltaY < 0) {
                return;
            }
            event.preventDefault();
            element.scrollLeft += event.deltaY * SCROLL_SPEED + event.deltaX;
        };
        var element = samplesRef.current;
        if (!element) {
            return;
        }
        element.addEventListener("wheel", handleWheel, {
            passive: false
        });
        return function() {
            return element.removeEventListener("wheel", handleWheel);
        };
    }, [
        samplesRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,clsx_m/* default */.Z)("flex flex-col items-center justify-center", "py-[16px] tablet:py-[40px] desktop:py-[55px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-6 flex flex-col gap-2 tablet:mb-9 tablet:w-[605px] tablet:gap-4 desktop:w-[875px] desktop:gap-[22px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-h3 max-w-[400px] self-center px-4 text-center tablet:p-0 desktop:max-w-none",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-body-2 hidden max-w-[800px] text-center tablet:block",
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("no-scrollbar w-full touch-pan-x overflow-y-hidden overflow-x-scroll", labels.length < 5 && "flex tablet:items-center tablet:justify-center"),
                ref: samplesRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("flex touch-pan-x gap-2 px-4 tablet:gap-3"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-10 w-[calc(50vw-500px)] shrink-0"
                        }),
                        labels.map(function(style, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithLabel, {
                                source: style.thumb,
                                label: style.name.toUpperCase()
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-10 w-[calc(50vw-500px)] min-w-[16px] shrink-0"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-body-2 mt-6 w-full max-w-[800px] px-4 text-center tablet:mt-9 tablet:hidden tablet:px-0",
                children: subtitle
            })
        ]
    });
}

// EXTERNAL MODULE: ./utils/millions.ts
var millions = __webpack_require__(323);
;// CONCATENATED MODULE: ./comps/feature/suggested-templates.tsx










var templateResponseSchema = lib.z.object({
    id: lib.z.string(),
    name: lib.z.string(),
    preview_webp_url: lib.z.string(),
    setups: lib.z.number(),
    views: lib.z.number(),
    price: lib.z.number()
});
var backEndTemplateResponseSchema = lib.z.object({
    result: templateResponseSchema
});
function SuggestedTemplates(props) {
    var templates = _feature_useFeaturePage().templates;
    var title = props.title, button_link = props.button_link, button_text = props.button_text, tool = props.tool, upload = props.upload;
    var onClick = (0,editor_editor/* useUploadOption */.Y4)(upload, tool).onClick;
    var editor = (0,editor_editor/* useEditorParamsContext */.mK)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full flex-col gap-4 py-[35px] tablet:gap-8 tablet:py-[40px] desktop:gap-8 desktop:py-[55px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-h2 w-full px-4 tablet:px-5 desktop:px-[calc(50vw-585px)]",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("no-scrollbar flex flex-row gap-[17px] overflow-x-scroll px-4", "tablet:gap-[17px] tablet:px-5 desktop:gap-[27px] desktop:px-[calc(50vw-585px)]"),
                    children: templates.map(function(template, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleTemplate, (0,_object_spread/* default */.Z)({}, template), index);
                    })
                }),
                button_text && tool !== "ai_music_generator" && /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                    href: button_link,
                    onClick: function() {
                        onClick && onClick();
                    },
                    loading: editor.loading,
                    className: "mt-8 tablet:mt-0 tablet:!w-[275px]",
                    text: button_text,
                    primary: true,
                    full: true
                }),
                button_text && tool === "ai_music_generator" && /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                    loading: editor.loading,
                    primary: true,
                    full: true,
                    onClick: onClick,
                    text: button_text,
                    className: "mt-8 tablet:mt-0 tablet:!w-[275px]"
                })
            ]
        })
    });
}
function SingleTemplate(props) {
    var id = props.id, preview_webp_url = props.preview_webp_url, name = props.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: "https://zoomerang.app/template/".concat(id),
            className: "flex w-[125px] shrink-0 flex-col gap-[7px] tablet:w-[169px] desktop:w-[174px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: preview_webp_url,
                    alt: name,
                    className: "h-[201px] w-full rounded-[14px] object-cover tablet:h-[272px] desktop:h-[280px]"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "body-4",
                    children: name
                })
            ]
        })
    });
}
function SuggestedTemplatesAlternative(props) {
    var templates = _feature_useFeaturePage().templates;
    var title = props.title, button_link = props.button_link, button_text = props.button_text, description = props.description, bubble_text = props.bubble_text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full flex-col items-center justify-center gap-4 px-4 py-[35px] tablet:gap-8 tablet:py-[40px] desktop:gap-9 desktop:py-[55px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center gap-3 tablet:w-[728px] tablet:items-start desktop:w-[1175px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-row justify-start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bubble/* default */.ZP, {
                                text: bubble_text,
                                color: "purplePink"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-h2 text-blue-900",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-full flex-col items-center justify-center gap-3 pb-4 tablet:flex-row tablet:items-end tablet:justify-between tablet:pb-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-body-3 w-[343px] text-center tablet:w-[450px] tablet:text-start desktop:w-[773px]",
                                    children: description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                    href: button_link,
                                    className: "tablet:!w-[210px]",
                                    text: button_text,
                                    primary: true,
                                    full: true
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid w-full grid-cols-2 gap-[15px] px-4 tablet:w-[729px] tablet:grid-cols-3 tablet:p-0 desktop:w-[1175px] desktop:grid-cols-4 desktop:gap-[25px]",
                    children: templates.map(function(single) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: "https://zoomerang.app/template/".concat(single.id),
                            className: "w-[calc(50vw - 24px)] flex flex-col items-stretch tablet:w-[233px] desktop:w-[275px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative aspect-[275/342] w-full overflow-hidden rounded-[12px] object-cover",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "absolute bottom-2 left-3 flex flex-row items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-row items-center gap-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/icons/player/play.png",
                                                            alt: "views",
                                                            className: "h-[10px] w-[10px]"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-[12px] font-700 text-color-white",
                                                            children: (0,millions/* default */.Z)(single.views)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-row items-center gap-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (0,cdn/* assetUrl */.p)("/player/shoots.svg"),
                                                            alt: "shoots",
                                                            className: "h-[8px] w-[8px]"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-[12px] font-700 text-color-white",
                                                            children: (0,millions/* default */.Z)(single.setups)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: single.preview_webp_url,
                                            alt: "preview image",
                                            className: "h-full w-full object-cover"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "ml-2 mt-[10px] h-[30px] text-[14px] font-700 tablet:ml-[10px] tablet:text-[16px]",
                                    children: single.name
                                })
                            ]
                        }, single.id);
                    })
                })
            ]
        })
    });
}
function SuggestedTemplatesOld(props) {
    var divideArray = function divideArray(arr, cols) {
        var result = [];
        for(var i = 0; i < cols; i++){
            result[i] = [];
        }
        for(var i1 = 0; i1 < arr.length; i1++){
            result[i1 % cols].push(arr[i1]);
        }
        return result;
    };
    var templates = useFeaturePage().templates;
    var title = props.title, button_link = props.button_link, button_text = props.button_text, description = props.description, bubble_text = props.bubble_text;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex w-full flex-col items-center justify-center gap-4 px-4 py-[35px] tablet:gap-8 tablet:py-[40px] desktop:gap-9 desktop:py-[55px]",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-col items-center gap-3 tablet:w-[728px] tablet:items-start desktop:w-[1175px]",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex flex-row justify-start",
                            children: /*#__PURE__*/ _jsx(Bubble, {
                                text: bubble_text,
                                color: "purplePink"
                            })
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "text-h2 text-blue-900",
                            children: title
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex w-full flex-col items-center justify-center gap-3 pb-4 tablet:flex-row tablet:items-end tablet:justify-between tablet:pb-0",
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    className: "text-body-3 w-[343px] text-center tablet:w-[450px] tablet:text-start desktop:w-[773px]",
                                    children: description
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    href: button_link,
                                    className: "tablet:!w-[210px]",
                                    text: button_text,
                                    primary: true,
                                    full: true
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        boxShadow: "0px 4px 27px 0px rgba(78, 96, 212, 0.46) inset"
                    },
                    className: "flex h-[555px] items-end justify-center overflow-hidden rounded-[18px] bg-[#E6ECF9] px-4 tablet:h-[460px] tablet:w-[728px] tablet:px-11 desktop:h-[630px] desktop:w-[1175px] desktop:rounded-[28px]",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "grid h-[775px] w-full grid-cols-2 gap-4 overflow-hidden tablet:h-[650px] tablet:grid-cols-4 tablet:gap-[22px] desktop:h-[938px] desktop:grid-cols-5 desktop:gap-[28px]",
                        children: divideArray(templates, 5).map(function(template, index) {
                            return /*#__PURE__*/ _jsx("div", {
                                className: "grid grid-rows-[10] gap-3 odd:pt-[100px] even:pb-[100px] tablet:grid-rows-5 tablet:gap-4 desktop:grid-rows-4",
                                children: template.map(function(single) {
                                    return /*#__PURE__*/ _jsxs("a", {
                                        href: "https://zoomerang.app/template/".concat(single.id),
                                        style: {
                                            boxShadow: "0px 3.54574px 20.56532px 0px rgba(123, 128, 158, 0.12)"
                                        },
                                        className: "relative h-[225px] shrink-0 overflow-hidden rounded-[9px] tablet:h-[232px] tablet:rounded-[12px] desktop:h-[300px]",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "absolute left-3 top-3 flex flex-row items-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("p", {
                                                        className: "text-[12px] font-700 text-color-white",
                                                        children: single.price
                                                    }),
                                                    /*#__PURE__*/ _jsx("img", {
                                                        src: assetUrl("/general/coin.svg"),
                                                        alt: "coins",
                                                        className: "h-3 w-3"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "absolute bottom-2 left-3 flex flex-row items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "flex flex-row items-center gap-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("img", {
                                                                src: "/icons/player/play.png",
                                                                alt: "views",
                                                                className: "h-[10px] w-[10px]"
                                                            }),
                                                            /*#__PURE__*/ _jsx("p", {
                                                                className: "text-[12px] font-700 text-color-white",
                                                                children: prettyMillions(single.views)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "flex flex-row items-center gap-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("img", {
                                                                src: assetUrl("/player/shoots.svg"),
                                                                alt: "shoots",
                                                                className: "h-[8px] w-[8px]"
                                                            }),
                                                            /*#__PURE__*/ _jsx("p", {
                                                                className: "text-[12px] font-700 text-color-white",
                                                                children: prettyMillions(single.setups)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("img", {
                                                src: single.preview_webp_url,
                                                alt: "suggested template",
                                                className: "h-full w-full object-cover"
                                            })
                                        ]
                                    }, single.id);
                                })
                            }, index);
                        })
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./comps/feature/text.tsx


var text_tagSchema = lib.z["enum"]([
    "h1",
    "h2",
    "h3",
    "h4"
]);
var textSchema = lib.z.object({
    component: lib.z.literal("text"),
    title: lib.z.string(),
    padding_top: lib.z.number().optional().default(0),
    padding_bottom: lib.z.number().optional().default(0),
    tag: text_tagSchema.default("h2")
});
function Text(props) {
    var title = props.title, padding_bottom = props.padding_bottom, padding_top = props.padding_top, tag = props.tag;
    switch(tag){
        case "h1":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                style: {
                    "--padding-top": padding_top + "px",
                    "--padding-bottom": padding_bottom + "px"
                },
                className: "self-center whitespace-pre-line px-4 py-[16px] text-center text-[30px] font-800 leading-tight tablet:px-0 tablet:py-[40px] tablet:text-[32px] desktop:max-w-[1000px] desktop:pb-[var(--padding-bottom)] desktop:pt-[var(--padding-top)] desktop:text-[64px]",
                children: title
            });
        case "h2":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                style: {
                    "--padding-top": padding_top + "px",
                    "--padding-bottom": padding_bottom + "px"
                },
                className: "self-center whitespace-pre-line px-4 py-[16px] text-center text-[30px] font-800 leading-tight tablet:px-0 tablet:py-[40px] tablet:text-[32px] desktop:max-w-[1000px] desktop:pb-[var(--padding-bottom)] desktop:pt-[var(--padding-top)] desktop:text-[64px]",
                children: title
            });
        case "h3":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                style: {
                    "--padding-top": padding_top + "px",
                    "--padding-bottom": padding_bottom + "px"
                },
                className: "self-center whitespace-pre-line px-4 py-[16px] text-center text-[24px] font-800 leading-tight tablet:px-0 tablet:py-[40px] tablet:text-[32px] desktop:max-w-[1000px] desktop:pb-[var(--padding-bottom)] desktop:pt-[var(--padding-top)] desktop:text-[64px]",
                children: title
            });
        case "h4":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                style: {
                    "--padding-top": padding_top + "px",
                    "--padding-bottom": padding_bottom + "px"
                },
                className: "self-center whitespace-pre-line px-4 py-[16px] text-center text-[24px] font-800 leading-tight tablet:px-0 tablet:py-[40px] tablet:text-[32px] desktop:max-w-[1000px] desktop:pb-[var(--padding-bottom)] desktop:pt-[var(--padding-top)] desktop:text-[64px]",
                children: title
            });
    }
}

;// CONCATENATED MODULE: ./comps/feature/textarea.tsx





















var textarea_tagSchema = lib.z["enum"]([
    "h1",
    "h2",
    "h3",
    "h4"
]);
var textarea_titleAttrSchema = lib.z.array(lib.z.object({
    start: lib.z.number(),
    length: lib.z.number(),
    color: lib.z.string().optional(),
    dark_color: lib.z.string().optional()
})).optional();
var textareaSchema = lib.z.object({
    component: lib.z.literal("headline-textarea"),
    bubble_text: lib.z.string().optional(),
    title: lib.z.string(),
    subtitle: lib.z.string(),
    button_text: lib.z.string(),
    without_background: lib.z.boolean().optional(),
    reversed: lib.z.boolean().optional(),
    without_qr: lib.z.boolean().optional(),
    tag: textarea_tagSchema.optional().default("h1"),
    title_attr: textarea_titleAttrSchema,
    left_icon: lib.z.string().optional(),
    right_icon: lib.z.string().optional(),
    className: lib.z.string().optional(),
    placeholder: lib.z.string(),
    words: lib.z.object({
        name: lib.z.string(),
        lightColor: lib.z.string(),
        darkColor: lib.z.string()
    }).array().optional(),
    platforms: lib.z.array(lib.z.union([
        lib.z.literal("ios"),
        lib.z.literal("android"),
        lib.z.literal("web"), 
    ])).optional()
});
function HeadlineTextArea(props) {
    var ref = (0,react.useState)(""), text = ref[0], setText = ref[1];
    var bubble_text = props.bubble_text, title = props.title, subtitle = props.subtitle, button_text = props.button_text, without_background = props.without_background, className = props.className, title_attr = props.title_attr, without_qr = props.without_qr, reversed = props.reversed, platforms = props.platforms, tag = props.tag, words = props.words, placeholder = props.placeholder, left_icon = props.left_icon, right_icon = props.right_icon;
    var acceptedPlatforms = platforms !== null && platforms !== void 0 ? platforms : [
        "ios",
        "android",
        "web", 
    ];
    var ref1 = (0,react.useState)(false), subscriptionPopupOpen = ref1[0], setSubscriptionPopupOpen = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var notify = (0,react.useContext)(notification/* NotificationContext */.u).notify;
    var t = (0,esm/* useTranslation */.$G)().t;
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var router = (0,next_router.useRouter)();
    function handleClick() {
        return _handleClick.apply(this, arguments);
    }
    function _handleClick() {
        _handleClick = (0,_async_to_generator/* default */.Z)(function() {
            var context, e, ref, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        if (userInfo.isAnonymous) {
                            router.push("/login?redirect_url=/chat?initial_message=".concat(text));
                            setIsLoading(false);
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        context = (0,functions/* isStringUrl */.b)(text);
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/wizard-start-session", {
                                context: context,
                                group: null,
                                tag: null
                            }).then(function(r) {
                                router.push("/chat?session_id=".concat(r.data.id));
                            })
                        ];
                    case 2:
                        _state.sent();
                        setText("");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        console.error(e);
                        if ((0,_instanceof/* default */.Z)(e, node_modules_axios/* AxiosError */.d7)) {
                            ;
                            if (((ref = e.response) === null || ref === void 0 ? void 0 : ref.status) === 431 || ((ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 432) {
                                setSubscriptionPopupOpen(true);
                            } else {
                                notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(comps_message/* ErrorMessage */.Bc, {
                                    children: t("txt_something_wrong")
                                }));
                            }
                        } else {
                            notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(comps_message/* ErrorMessage */.Bc, {
                                children: t("txt_something_wrong")
                            }));
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleClick.apply(this, arguments);
    }
    var ref3 = (0,react.useState)([]), inputHistory = ref3[0], _ = ref3[1];
    (0,react.useEffect)(function() {
        var handleUndo = function(e) {
            if (e.ctrlKey && e.key === "z" || e.metaKey && e.key === "z") {
                if (inputHistory.length > 0) {
                    var ref;
                    setText && setText((ref = inputHistory.pop()) !== null && ref !== void 0 ? ref : "");
                }
            }
        };
        window.addEventListener("keydown", handleUndo);
        return function() {
            window.removeEventListener("keydown", handleUndo);
        };
    }, [
        text,
        inputHistory,
        setText
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "relative flex w-full items-center justify-center px-4 tablet:px-0 desktop:px-[calc(50vw-702px)]",
                children: [
                    !without_background && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,cdn/* assetUrl */.p)("/comps/textarea-bg.webp"),
                        alt: "bg-picture",
                        className: "absolute left-0 top-0 h-[330px] w-full dark:opacity-40 tablet:h-auto tablet:max-h-[600px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)("relative flex w-full flex-col items-center gap-6 tablet:w-[720px] tablet:items-start tablet:justify-between desktop:w-full desktop:px-[30px]", reversed ? "tablet:flex-row-reverse" : "tablet:flex-row", className ? className : "py-[35px] tablet:py-[40px] desktop:pb-[60px] desktop:pt-[100px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex w-full flex-col items-center gap-2 tablet:w-auto tablet:max-w-[295px] tablet:items-start desktop:max-w-[600px]",
                                children: [
                                    bubble_text && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "z-[1] flex flex-row justify-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bubble/* default */.ZP, {
                                            text: bubble_text,
                                            color: "pinkPurpleLight"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GetHeader, {
                                        tag: tag,
                                        title: title,
                                        title_attr: title_attr,
                                        textStart: true,
                                        children: words && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedWords, {
                                            words: words
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "font z-[1] font-400 leading-[1.618] text-blue-700 tablet:mt-[20px] tablet:text-[16px] desktop:text-[18px]",
                                        children: subtitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex w-full flex-col justify-center tablet:mt-10 tablet:w-auto desktop:mt-11",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative z-20 flex h-[170px] w-full rounded-[8px] border border-color-separator bg-color-cell pb-5 tablet:w-[356px] desktop:w-[546px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                disabled: isLoading,
                                                placeholder: placeholder,
                                                className: (0,clsx_m/* default */.Z)("text-body-5 no-scrollbar h-full w-full resize-none rounded-[14px] bg-color-cell py-2 pl-3 pr-3 placeholder:text-color-placeholder focus-visible:outline-none", isLoading ? "text-color-placeholder" : "text-blue-800"),
                                                value: text,
                                                onChange: function(e) {
                                                    var inputValue = e.currentTarget.value;
                                                    if (inputValue.length <= 1000) {
                                                        setText(inputValue);
                                                    }
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                disabled: isLoading,
                                                onClick: function() {
                                                    setText("");
                                                },
                                                className: (0,clsx_m/* default */.Z)("absolute bottom-2 right-3 flex h-[17px] w-[17px] items-center justify-center rounded-full", "bg-blue-200 transition-all hover:bg-blue-400 disabled:opacity-40", text.length === 0 ? "pointer-events-none opacity-0" : "opacity-100"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                                    format: "svg",
                                                    source: "/general/close",
                                                    className: "h-[12px] w-[12px]"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        onClick: function(e) {
                                            e.preventDefault();
                                            if (text.trim().length === 0) {
                                                return;
                                            }
                                            handleClick();
                                        },
                                        disabled: isLoading || text.trim().length === 0,
                                        className: (0,clsx_m/* default */.Z)("z-[1] mt-7 flex w-full shrink-0 select-none flex-row items-center justify-center gap-2 text-[18px] font-600", "rounded-[6px] tablet:mt-4 desktop:mt-5 desktop:h-[64px] desktop:w-full desktop:rounded-[10px]", "bg-primary-500 text-color-white transition-colors duration-300 ease-in-out hover:bg-primary-600", "cursor-pointer disabled:cursor-not-allowed disabled:opacity-50", "px-[34px] py-[14px]"),
                                        children: [
                                            left_icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: left_icon,
                                                alt: "left icon"
                                            }),
                                            button_text,
                                            right_icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: right_icon,
                                                alt: "right icon"
                                            })
                                        ]
                                    }),
                                    !without_qr && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlatformsSection, {
                                        platforms: acceptedPlatforms
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(subscription_popup/* SubscriptionPopup */.yj, {
                isOpen: subscriptionPopupOpen,
                close: function() {
                    return setSubscriptionPopupOpen(false);
                },
                location: router.asPath
            })
        ]
    });
}

// EXTERNAL MODULE: ./comps/tooltip.tsx
var tooltip = __webpack_require__(4773);
;// CONCATENATED MODULE: ./comps/feature/icons.tsx

var DeformAi = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13.7711 10.7498C14.3011 10.3977 14.3011 9.60163 13.7711 9.24955L8.84521 5.97781C8.26607 5.59315 7.50195 6.01987 7.50195 6.72794V13.2714C7.50195 13.9795 8.26608 14.4062 8.84521 14.0215L13.7711 10.7498Z",
                    fill: "var(--icon-color)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M13.3364 4.22785C12.175 3.55682 10.8381 3.25175 9.50058 3.35249C8.16303 3.45324 6.88697 3.95512 5.83916 4.79255C4.79134 5.62998 4.02051 6.76401 3.62739 8.04645C3.23426 9.32889 3.23713 10.7001 3.63562 11.9809C4.03411 13.2617 4.80969 14.3925 5.861 15.2255C6.91231 16.0585 8.19046 16.5551 9.52843 16.6502C9.9875 16.6828 10.3332 17.0815 10.3006 17.5405C10.2679 17.9996 9.86929 18.3453 9.41021 18.3127C7.73775 18.1937 6.14006 17.5731 4.82593 16.5318C3.51179 15.4905 2.54232 14.077 2.0442 12.476C1.54609 10.875 1.5425 9.16104 2.03391 7.55798C2.52531 5.95493 3.48885 4.53739 4.79862 3.4906C6.10839 2.44382 7.70346 1.81647 9.3754 1.69054C11.0473 1.5646 12.7184 1.94595 14.1702 2.78473C15.622 3.62352 16.787 4.88073 17.513 6.39209C18.2389 7.90345 18.4921 9.59865 18.2395 11.2562C18.1701 11.7112 17.745 12.0238 17.2901 11.9544C16.8351 11.8851 16.5225 11.46 16.5918 11.005C16.794 9.67899 16.5914 8.32282 16.0106 7.11374C15.4298 5.90465 14.4978 4.89888 13.3364 4.22785Z",
                    fill: "var(--icon-color)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.5013 17.661V13.869C17.4758 13.1559 16.5546 13.1554 16.5289 13.869V17.661C16.5543 18.3742 17.4756 18.3747 17.5013 17.661ZM14.7537 14.2158C14.5859 13.6779 14.1303 13.3318 13.5941 13.334C13.0571 13.3361 12.6043 13.6862 12.4404 14.2259C12.4368 14.2379 11.6815 17.5422 11.6815 17.5422C11.6158 17.8298 11.7951 18.1163 12.0819 18.1822C12.369 18.2481 12.6546 18.0683 12.7203 17.7807L12.8635 17.1539H14.3568L14.5065 17.7851C14.5735 18.0743 14.8694 18.25 15.1482 18.1812C15.4344 18.1129 15.6113 17.8248 15.5432 17.5378C15.5432 17.5378 14.7574 14.2276 14.7537 14.2158ZM13.1286 16.2519L13.4772 14.4465C13.5037 14.3567 13.5498 14.3073 13.6079 14.3071H13.6084C13.6667 14.3071 13.7116 14.3544 13.7386 14.4442L14.101 16.2519H13.1286Z",
                    fill: "var(--icon-color)"
                })
            ]
        })
    });
};
var PhotoAi = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.7 8.6998C8.6 8.6998 9.4 7.8998 9.4 6.9998C9.4 6.0998 8.7 5.2998 7.7 5.2998C6.7 5.2998 6 6.0998 6 6.9998C6 7.8998 6.8 8.6998 7.7 8.6998Z",
                    fill: "var(--icon-color)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.0008 17.1998C11.0008 17.0998 11.0008 16.9998 11.0008 16.8998L11.7008 13.8998C12.0008 12.9998 12.8008 12.2998 13.8008 12.2998C14.5008 12.2998 15.1008 12.5998 15.5008 13.0998C15.8008 12.5998 16.3008 12.2998 16.9008 12.2998C17.4008 12.2998 17.8008 12.4998 18.1008 12.8998C18.1008 12.7998 18.1008 12.5998 18.1008 12.4998V7.79981C18.1008 5.89981 17.7008 4.29981 16.7008 3.19981C15.6008 2.0998 14.1008 1.7998 12.1008 1.7998H7.80078C5.90078 1.7998 4.30078 2.1998 3.20078 3.19981C2.10078 4.19981 1.80078 5.79981 1.80078 7.79981V12.2998C1.80078 14.1998 2.20078 15.7998 3.20078 16.8998C4.20078 17.9998 5.80078 18.2998 7.80078 18.2998H11.4008C11.1008 17.9998 11.0008 17.5998 11.0008 17.1998ZM9.60078 12.5998L9.40078 12.3998C8.60078 11.6998 7.40078 11.5998 6.50078 12.1998L3.50078 14.2998C3.40078 13.7998 3.30078 13.0998 3.30078 12.2998V7.79981C3.30078 5.99981 3.70078 4.89981 4.30078 4.29981C4.90078 3.69981 6.00078 3.2998 7.80078 3.2998H12.3008C14.1008 3.2998 15.2008 3.69981 15.8008 4.29981C16.4008 4.89981 16.8008 5.99981 16.8008 7.79981V9.79981C15.9008 9.09981 14.6008 9.09981 13.8008 9.79981L10.7008 12.4998C10.4008 12.7998 9.90078 12.7998 9.60078 12.5998Z",
                    fill: "var(--icon-color)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.3994 17.4002V13.6002C17.3994 12.9002 16.4994 12.9002 16.3994 13.6002V17.4002C16.4994 18.1002 17.3994 18.1002 17.3994 17.4002ZM14.9994 14.0002C14.7994 13.5002 14.3995 13.1002 13.7995 13.1002C13.2995 13.1002 12.7995 13.5002 12.5995 14.0002L11.7995 17.3002C11.6995 17.6002 11.8995 17.9002 12.1995 17.9002C12.4995 18.0002 12.7995 17.8002 12.7995 17.5002L12.8994 16.9002H14.3994L14.4994 17.5002C14.5994 17.8002 14.8995 18.0002 15.0995 17.9002C15.3995 17.8002 15.5994 17.5002 15.4994 17.3002C15.7994 17.3002 14.9994 14.0002 14.9994 14.0002ZM13.3994 16.0002L13.6994 14.2002C13.6994 14.1002 13.7995 14.1002 13.7995 14.1002C13.8995 14.1002 13.8994 14.1002 13.8994 14.2002L14.2995 16.0002H13.3994Z",
                    fill: "var(--icon-color)"
                })
            ]
        })
    });
};
var GenerativeFill = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.7498 8.34251L13.26 10.6411C13.377 11.1697 13.6255 11.6276 13.9735 11.9828C14.3215 12.338 14.7711 12.5916 15.2885 12.7107L17.5409 13.2311C17.6455 13.2565 17.7359 13.322 17.7927 13.4133C17.8496 13.5047 17.8682 13.6148 17.8448 13.7198C17.8286 13.7949 17.7915 13.8639 17.7377 13.9188C17.6839 13.9736 17.6157 14.0122 17.5409 14.0298L15.2885 14.5503C14.7895 14.6619 14.3331 14.9146 13.9735 15.2782C13.6147 15.6498 13.3675 16.1147 13.26 16.6199L12.7498 18.9185C12.7391 18.9705 12.7181 19.0199 12.6881 19.0638C12.6581 19.1076 12.6197 19.1451 12.575 19.1739C12.5304 19.2028 12.4805 19.2225 12.4282 19.2319C12.3759 19.2412 12.3222 19.2401 12.2704 19.2285C12.1955 19.2109 12.1272 19.1725 12.0734 19.1176C12.0196 19.0627 11.9826 18.9936 11.9665 18.9185L11.4563 16.6199C11.3491 16.1146 11.1019 15.6496 10.7428 15.2782C10.3835 14.9146 9.92745 14.6616 9.42876 14.5493L7.17539 14.0288C7.07059 14.0034 6.97998 13.9378 6.92312 13.8462C6.86627 13.7546 6.84773 13.6443 6.87152 13.5391C6.8877 13.464 6.92483 13.395 6.97861 13.3401C7.03239 13.2853 7.10062 13.2468 7.17539 13.2291L9.42876 12.7086C9.92779 12.597 10.3842 12.3443 10.7438 11.9808C11.0908 11.6256 11.3403 11.1677 11.4573 10.639L11.9675 8.34046C11.9782 8.28841 11.9992 8.23901 12.0292 8.19515C12.0592 8.15128 12.0976 8.11383 12.1423 8.08497C12.1869 8.05612 12.2368 8.03643 12.2891 8.02707C12.3414 8.0177 12.3951 8.01884 12.4469 8.03043C12.5218 8.04799 12.5901 8.08646 12.6439 8.14135C12.6977 8.19625 12.7347 8.2653 12.7508 8.34046L12.7498 8.34251ZM15.1048 1.0804L15.3409 2.14292C15.3833 2.3397 15.4804 2.52049 15.6212 2.66443C15.7598 2.79891 15.925 2.89028 16.116 2.9334L17.158 3.17362C17.2626 3.19901 17.353 3.26443 17.4098 3.35582C17.4666 3.44721 17.4853 3.55726 17.4618 3.66228C17.4457 3.73739 17.4085 3.80638 17.3548 3.86125C17.301 3.91612 17.2327 3.95463 17.158 3.97231L16.116 4.21253C15.9178 4.25873 15.7454 4.35523 15.6129 4.48971C15.4805 4.6242 15.3861 4.8018 15.3409 5.00301L15.1048 6.06553C15.0941 6.11758 15.0731 6.16698 15.0431 6.21084C15.0131 6.2547 14.9747 6.29216 14.93 6.32101C14.8854 6.34987 14.8355 6.36956 14.7832 6.37892C14.7309 6.38829 14.6772 6.38714 14.6254 6.37556C14.5505 6.35799 14.4823 6.31952 14.4285 6.26463C14.3747 6.20974 14.3376 6.14069 14.3215 6.06553L14.0854 5.00301C14.0444 4.80987 13.9502 4.63206 13.8133 4.48971C13.6753 4.35148 13.5009 4.25534 13.3103 4.21253L12.2683 3.97231C12.1637 3.94692 12.0733 3.8815 12.0165 3.79011C11.9596 3.69872 11.941 3.58867 11.9644 3.48365C11.9806 3.40854 12.0177 3.33955 12.0715 3.28468C12.1253 3.22981 12.1935 3.1913 12.2683 3.17362L13.3103 2.9334C13.5046 2.88944 13.6818 2.78992 13.8205 2.64698C13.9529 2.50622 14.0441 2.33189 14.0844 2.14292L14.3205 1.0804C14.3312 1.02835 14.3522 0.978952 14.3822 0.935089C14.4122 0.891225 14.4506 0.853773 14.4952 0.824916C14.5398 0.796058 14.5898 0.776373 14.6421 0.767008C14.6944 0.757643 14.748 0.758786 14.7999 0.770369C14.8747 0.787935 14.943 0.826406 14.9968 0.881296C15.0506 0.936187 15.0887 1.00524 15.1048 1.0804ZM6.52556 2.82047L6.88384 4.43838C6.95481 4.77171 7.1181 5.07836 7.35504 5.3233L7.37147 5.34178C7.59835 5.56558 7.88887 5.72676 8.22149 5.80375L9.80655 6.16922C9.91113 6.1946 10.0016 6.26003 10.0584 6.35142C10.1152 6.44281 10.1339 6.55285 10.1104 6.65787C10.0942 6.73299 10.0571 6.80197 10.0033 6.85685C9.94955 6.91172 9.88132 6.95022 9.80655 6.9679L8.22149 7.3344C7.87963 7.41345 7.58295 7.58078 7.35402 7.81382C7.12509 8.04685 6.96186 8.35072 6.88384 8.69977L6.52556 10.3177C6.51484 10.3697 6.49388 10.4191 6.46388 10.463C6.43388 10.5068 6.39544 10.5443 6.35082 10.5732C6.3062 10.602 6.25627 10.6217 6.20396 10.6311C6.15165 10.6404 6.098 10.6393 6.04614 10.6277C5.97131 10.6101 5.90302 10.5717 5.84922 10.5168C5.79542 10.4619 5.75833 10.3928 5.74227 10.3177L5.38296 8.69977C5.31222 8.36657 5.14931 8.05995 4.91278 7.81484C4.67609 7.57483 4.37529 7.40804 4.04634 7.3344L2.46025 6.9679C2.35567 6.94252 2.26524 6.87709 2.20841 6.7857C2.15158 6.69432 2.1329 6.58427 2.15638 6.47925C2.17256 6.40414 2.20969 6.33515 2.26347 6.28028C2.31725 6.2254 2.38548 6.1869 2.46025 6.16922L4.04531 5.80375C4.38614 5.7247 4.68282 5.55737 4.91176 5.3233L4.93023 5.30585C5.14992 5.07487 5.30802 4.77818 5.38296 4.43838L5.74227 2.82047C5.75298 2.76842 5.77395 2.71903 5.80395 2.67516C5.83395 2.6313 5.87238 2.59385 5.91701 2.56499C5.96163 2.53613 6.01155 2.51645 6.06386 2.50708C6.11617 2.49772 6.16982 2.49886 6.22169 2.51044C6.29651 2.52801 6.3648 2.56648 6.4186 2.62137C6.4724 2.67626 6.5095 2.74531 6.52556 2.82047Z",
                fill: "var(--icon-color)"
            })
        })
    });
};
var BGRemover = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M4.40852 0.416992C4.97283 0.416992 5.24232 1.11079 4.82597 1.4917L3.11448 3.05754C2.71974 3.41868 2.08398 3.13865 2.08398 2.60363C2.08398 2.43157 2.15604 2.26737 2.28266 2.15087L3.98981 0.5803C4.10396 0.475281 4.25341 0.416992 4.40852 0.416992Z",
                    fill: "var(--icon-color)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.0047 0.416992C10.5961 0.416992 10.8796 1.14304 10.4448 1.54382L3.16369 8.25512C2.75135 8.63519 2.08398 8.34271 2.08398 7.78192C2.08398 7.60241 2.15896 7.43105 2.29081 7.30923L9.56404 0.5894C9.68402 0.478552 9.84136 0.416992 10.0047 0.416992Z",
                    fill: "var(--icon-color)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.14309 9.35646C7.23404 9.595 7.19579 9.87317 7.00498 10.0428L3.12161 13.4947C2.71956 13.852 2.08398 13.5666 2.08398 13.0287C2.08398 12.8515 2.15935 12.6828 2.29125 12.5645L6.1981 9.06181C6.50983 8.78233 6.99393 8.96526 7.14309 9.35646Z",
                    fill: "var(--icon-color)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M4.062 16.2272C4.30806 16.0067 4.68362 16.0169 4.91732 16.2505C5.26088 16.594 4.91734 17.084 4.83398 17.1672L3.1138 18.731C2.71831 19.0905 2.08398 18.8099 2.08398 18.2754C2.08398 18.1005 2.15842 17.9338 2.28868 17.817L4.062 16.2272Z",
                    fill: "var(--icon-color)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.084 4C9.91732 4 8.08398 5.75 8.08398 8C8.08398 8.08333 8.08398 8.08333 8.08398 8.16667C8.08398 8.5 8.16732 8.91667 8.25065 9.25C8.50065 10.0833 9.08398 10.8333 9.83398 11.3333C10.2507 11.5833 10.6673 11.75 11.084 11.9167C11.4173 12 11.7507 12.0833 12.084 12.0833C14.2507 12.0833 16.084 10.3333 16.084 8.08333C16.084 5.83333 14.2507 4 12.084 4ZM12.084 10.6667C10.584 10.6667 9.41732 9.41667 9.41732 8C9.41732 6.5 10.6673 5.33333 12.084 5.33333C13.5007 5.33333 14.7507 6.58333 14.7507 8C14.7507 9.41667 13.584 10.6667 12.084 10.6667Z",
                    fill: "var(--icon-color)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M6.33073 18.584C5.91406 18.584 5.66406 18.2507 5.66406 17.9173C5.66406 16.084 6.41406 13.084 11.5807 13.084C11.6797 13.084 11.7775 13.0852 11.8741 13.0875C11.9707 13.0852 12.0685 13.084 12.1674 13.084C17.3341 13.084 18.0841 16.084 18.0841 17.9173C18.0841 18.2507 17.8341 18.584 17.4174 18.584C17.4015 18.584 17.3859 18.5836 17.3705 18.5829C17.3578 18.5836 17.3445 18.584 17.3307 18.584C16.9141 18.584 16.6641 18.2507 16.6641 17.9173C16.6641 16.3394 16.0847 14.4304 11.8741 14.4174C7.66345 14.4304 7.08409 16.3394 7.08409 17.9173C7.08409 18.2507 6.83409 18.584 6.41742 18.584C6.40362 18.584 6.39037 18.5836 6.37764 18.5829C6.36225 18.5836 6.34661 18.584 6.33073 18.584Z",
                    fill: "var(--icon-color)"
                })
            ]
        })
    });
};
var RestyleAi = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M11.196 6.71154C10.8083 6.71154 10.4941 7.0258 10.4941 7.41346C10.4941 7.80112 10.8083 8.11538 11.196 8.11538C11.5837 8.11538 11.8979 7.80112 11.8979 7.41346C11.8979 7.0258 11.5837 6.71154 11.196 6.71154Z",
                    fill: "var(--icon-color)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M1.79634 3.39081C2.62707 2.70003 3.85423 2.5 5.37854 2.5H11.3977C12.9221 2.5 14.1492 2.70003 14.9799 3.39081C15.7624 4.04144 16.0505 4.99851 16.1009 6.1419L16.7726 5.65208C17.3481 5.2341 18.121 4.97968 18.8276 5.36334C19.5186 5.73856 19.7503 6.51386 19.7503 7.22819V12.5144C19.7503 13.2279 19.519 14.0049 18.8259 14.3792C18.1173 14.7619 17.3444 14.5028 16.7703 14.0819L16.7692 14.0811L16.1011 13.5938C16.0508 14.7405 15.7603 15.6989 14.9759 16.35C14.1443 17.0401 12.9179 17.2404 11.3977 17.2404H8.80111C8.80493 17.2021 8.80757 17.1634 8.80898 17.124L8.80959 17.1072V12.6942L8.80899 12.6775C8.77702 11.7817 8.10895 11.1573 7.31251 11.1571C6.51565 11.1568 5.84755 11.7814 5.81532 12.6772L5.81471 12.6941V13.7562L5.62021 12.9388L5.61185 12.904L5.60896 12.8921L5.60704 12.8844L5.6048 12.8756L5.602 12.8651C5.60054 12.8598 5.5959 12.8437 5.59262 12.833C5.28477 11.8465 4.41343 11.1527 3.35583 11.1571C2.29719 11.1614 1.4319 11.8628 1.13163 12.8519C1.12843 12.8627 1.12391 12.8788 1.12249 12.8841L1.11976 12.8947L1.11757 12.9036L1.1157 12.9113L1.11291 12.9233L1.10486 12.9581L0.798634 14.2965C0.707338 13.9345 0.666992 13.5652 0.666992 13.2043V6.53606C0.666992 5.21849 0.925574 4.11488 1.79634 3.39081ZM9.09023 7.41346C9.09023 6.25048 10.033 5.30769 11.196 5.30769C12.359 5.30769 13.3018 6.25048 13.3018 7.41346C13.3018 8.57645 12.359 9.51923 11.196 9.51923C10.033 9.51923 9.09023 8.57645 9.09023 7.41346ZM17.752 7.00062L16.2407 8.10277V11.6328L17.7533 12.736L17.7553 12.7374C17.8819 12.8303 17.9745 12.8706 18.0292 12.887C18.0542 12.8248 18.0837 12.7062 18.0837 12.5144V7.22819C18.0837 7.03337 18.0532 6.91406 18.028 6.85238C17.9737 6.86797 17.88 6.90773 17.752 7.00062Z",
                    fill: "var(--icon-color)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.35939 12.093C3.97865 12.0904 4.50484 12.4902 4.69868 13.1113C4.70296 13.1251 5.61046 16.9481 5.61046 16.9481C5.68913 17.2795 5.48483 17.6123 5.15423 17.6911C4.83231 17.7706 4.49048 17.5677 4.41316 17.2336L4.24021 16.5047H2.51561L2.35023 17.2286C2.27436 17.5608 1.94456 17.7684 1.61301 17.6923C1.28176 17.6162 1.07472 17.2853 1.1506 16.9531C1.1506 16.9531 2.02286 13.1369 2.02705 13.1231C2.21627 12.4998 2.73923 12.0954 3.35939 12.093ZM3.22203 13.3771L2.81949 15.4622H3.94254L3.52399 13.3744C3.49274 13.2707 3.44096 13.216 3.37362 13.216C3.30647 13.2164 3.25268 13.2733 3.22203 13.3771Z",
                    fill: "var(--icon-color)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.87339 12.7109V17.0904C7.84374 17.9146 6.77974 17.914 6.75034 17.0904V12.7109C6.77999 11.8867 7.84399 11.8873 7.87339 12.7109Z",
                    fill: "var(--icon-color)"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./comps/feature/tools.tsx











var tools_featureAiToolSchema = lib.z["enum"]([
    "deform",
    "ai_photo",
    "ai_restyle",
    "text_to_image",
    "text_to_video",
    "ai_music_generator", 
]);
var toolSchema = lib.z.object({
    name: lib.z.string(),
    description: lib.z.string(),
    link: lib.z.string(),
    icon: lib.z.string(),
    media: lib.z.string()
});
var toolComponent = lib.z.object({
    component: lib.z.literal("tools"),
    tools: lib.z.array(toolSchema),
    button_text: lib.z.string().optional(),
    button_link: lib.z.string().optional(),
    upload: lib.z.boolean().optional(),
    tool: tools_featureAiToolSchema.optional()
});
function ToolsOld(props) {
    var tools = props.tools;
    return /*#__PURE__*/ _jsx("section", {
        className: "pt-[35px] tablet:pt-[40px] desktop:pt-[55px] ",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "relative flex h-[400px] w-full items-center bg-gradient-to-r from-[#E5F0F599] via-[#E5F0F599] to-[#EA919699] dark:from-[#1e435247] dark:via-[#1e43524f] dark:to-[#b3232a40] tablet:h-[444px] desktop:h-[535px]",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "pointer-events-none absolute left-0 top-0 z-10 w-full overflow-hidden mix-blend-overlay",
                    children: /*#__PURE__*/ _jsx(ResponsiveImage, {
                        src: "/feature/noise",
                        className: "w-full object-cover dark:opacity-50"
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "z-20 flex w-full flex-col items-center gap-8",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "text-h5",
                            children: "Other helpful tools"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "no-scrollbar flex w-full flex-row gap-3 overflow-x-scroll px-4 tablet:w-[615px] tablet:justify-center tablet:overflow-hidden desktop:w-[930px]",
                            children: tools.map(function(tool, index) {
                                return /*#__PURE__*/ _jsx(SingleToolOld, {
                                    tool: tool,
                                    image: tool.icon
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            primary: true,
                            text: "See All Tools",
                            href: "https://zoomerang.app",
                            className: "w-[80%] tablet:w-[315px] desktop:mt-14"
                        })
                    ]
                })
            ]
        })
    });
}
function Tools(props) {
    var tools = props.tools, button_text = props.button_text, button_link = props.button_link, upload = props.upload, tool = props.tool;
    var onClick = (0,editor_editor/* useUploadOption */.Y4)(upload, tool).onClick;
    var editor = (0,editor_editor/* useEditorParamsContext */.mK)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "py-[35px] tablet:py-[40px] desktop:py-[55px] ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative flex w-full items-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "z-20 flex w-full flex-col items-center gap-8 tablet:py-[20px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-h5",
                        children: "Other helpful tools"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("no-scrollbar w-full touch-pan-x overflow-y-hidden overflow-x-scroll px-4", tools.length < 5 && "flex desktop:items-center desktop:justify-center"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)("flex touch-pan-x gap-2 tablet:gap-3"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-10 w-[calc(50vw-500px)] shrink-0"
                                }),
                                tools.map(function(tool, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleTool, {
                                        tool: tool
                                    }, index);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-10 w-[calc(50vw-500px)] shrink-0"
                                })
                            ]
                        })
                    }),
                    button_text && tool !== "ai_music_generator" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                href: button_link,
                                onClick: function() {
                                    onClick && onClick();
                                },
                                loading: editor.loading,
                                className: "hidden w-[80%] tablet:w-[315px] desktop:block",
                                text: button_text,
                                primary: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                href: branch/* appStoreConstant */.HY,
                                text: button_text,
                                primary: true,
                                full: true,
                                className: "w-[80%] tablet:!w-[315px] desktop:hidden"
                            })
                        ]
                    }),
                    button_text && tool === "ai_music_generator" && /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                        loading: editor.loading,
                        primary: true,
                        onClick: onClick,
                        text: button_text,
                        className: "w-[80%] tablet:!w-[315px]"
                    })
                ]
            })
        })
    });
}
function SingleTool(props) {
    var _tool = props.tool, name = _tool.name, link = _tool.link, icon = _tool.icon, media = _tool.media, description = _tool.description;
    var player = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (player.current) if (player.current.clientHeight >= 208) player.current.autoplay = false;
        else player.current.play().catch(console.error);
    }, [
        player
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: link,
            className: (0,clsx_m/* default */.Z)("flex w-[277px] shrink-0 flex-row items-center justify-between gap-[10px] rounded-[8px] bg-color-surface py-[8px] pl-[8px] pr-[12px]", "tablet:w-[233px] tablet:items-start tablet:justify-start tablet:p-0 tablet:pb-4 desktop:w-[200px]"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("flex flex-row items-center gap-[10px]", "tablet:w-full tablet:flex-col tablet:gap-[14px]"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            muted: true,
                            loop: true,
                            autoPlay: true,
                            playsInline: true,
                            preload: "metadata",
                            ref: player,
                            onPointerEnter: function(e) {
                                e.currentTarget.play().catch(console.error);
                            },
                            onPointerLeave: function(e) {
                                e.currentTarget.pause();
                                e.currentTarget.currentTime = 0.001;
                            },
                            onTouchMove: function(e) {
                                e.currentTarget.play().catch(console.error);
                            },
                            onTouchEnd: function(e) {
                                e.currentTarget.pause();
                                e.currentTarget.currentTime = 0.001;
                            },
                            src: media,
                            className: (0,clsx_m/* default */.Z)("aspect-1 h-[88px] rounded-[6px] object-cover object-top", "transition-all duration-300 tablet:rounded-[8px] tablet:hover:rounded", "tablet:aspect-none tablet:h-[208px] tablet:w-full desktop:h-[200px]")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-[3px] tablet:w-full tablet:gap-[10px] tablet:px-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-start gap-[3px] text-[16px] font-600 text-blue-700 tablet:flex-row tablet:items-center tablet:gap-3 tablet:text-[20px] tablet:text-blue-800 desktop:text-[16px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-5 w-5 [--icon-color:var(--color-blue-700)] tablet:[--icon-color:var(--color-blue-800)]",
                                            children: getIconByName(icon)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.ZP, {
                                            className: "w-[140px]",
                                            width: 180,
                                            title: name,
                                            showAlways: name.length > 15,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: " w-[140px] truncate leading-[19px] tablet:w-auto tablet:leading-normal",
                                                children: name
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "line-clamp-2 w-full text-[12px] font-400 leading-[15px] text-blue-600 tablet:text-[16px] tablet:leading-normal tablet:text-blue-700",
                                    children: description
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "[--icon-color:var(--color-placeholder)] tablet:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tools.Arrow, {})
                })
            ]
        })
    });
}
function SingleToolOld(props) {
    var image = props.image, tool = props.tool;
    var link = tool.link, name = tool.name;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("a", {
            href: link,
            className: "flex h-[178px] w-[145px] shrink-0 flex-col items-center justify-center gap-2 rounded-[30px] bg-color-cell px-5",
            children: [
                /*#__PURE__*/ _jsx("img", {
                    src: image,
                    alt: "tool_image",
                    className: "h-12 w-12 object-cover"
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text-body-5 text-color-placeholder",
                    children: name
                })
            ]
        })
    });
}
function getIconByName(icon) {
    switch(icon){
        case "deform_ai":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeformAi, {});
        case "photo_ai":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PhotoAi, {});
        case "generative_fill":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GenerativeFill, {});
        case "bg_remover":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BGRemover, {});
        case "restyle_ai":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RestyleAi, {});
    }
}

;// CONCATENATED MODULE: ./comps/feature/usecases.tsx







var usecases_featureAiToolSchema = lib.z["enum"]([
    "deform",
    "ai_photo",
    "ai_restyle",
    "text_to_image",
    "text_to_video",
    "ai_music_generator", 
]);
var usecases_SCROLL_SPEED = 0.8;
function usecases_ImageWithLabel(props) {
    var source = props.source, label = props.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-[125px] shrink-0 flex-col gap-[7px] tablet:w-[169px] desktop:w-[174px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: source,
                    alt: label,
                    className: "h-[201px] w-full rounded-[14px] object-cover tablet:h-[272px] desktop:h-[280px]"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "body-4",
                    children: label
                })
            ]
        })
    });
}
var usecasesSchema = lib.z.object({
    component: lib.z.literal("usecases"),
    title: lib.z.string(),
    subtitle: lib.z.string().optional(),
    button_text: lib.z.string().optional(),
    button_link: lib.z.string().optional(),
    labels: lib.z.array(lib.z.object({
        name: lib.z.string(),
        thumb: lib.z.string()
    })),
    upload: lib.z.boolean().optional(),
    tool: usecases_featureAiToolSchema.optional()
});
function Usecases(props) {
    var labels = props.labels, title = props.title, subtitle = props.subtitle, button_text = props.button_text, button_link = props.button_link, upload = props.upload, tool = props.tool;
    var samplesRef = (0,react.useRef)(null);
    var onClick = (0,editor_editor/* useUploadOption */.Y4)(upload, tool).onClick;
    var editor = (0,editor_editor/* useEditorParamsContext */.mK)();
    (0,react.useEffect)(function() {
        var handleWheel = function handleWheel(event) {
            if (!element) {
                return;
            }
            var isAtRightEdge = element.scrollLeft + element.clientWidth >= element.scrollWidth;
            var isAtLeftEdge = element.scrollLeft === 0;
            if (isAtRightEdge && event.deltaY > 0) {
                return;
            }
            if (isAtLeftEdge && event.deltaY < 0) {
                return;
            }
            event.preventDefault();
            element.scrollLeft += event.deltaY * usecases_SCROLL_SPEED + event.deltaX;
        };
        var element = samplesRef.current;
        if (!element) {
            return;
        }
        element.addEventListener("wheel", handleWheel, {
            passive: false
        });
        return function() {
            return element.removeEventListener("wheel", handleWheel);
        };
    }, [
        samplesRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,clsx_m/* default */.Z)("flex flex-col items-center justify-center", "py-[16px] tablet:py-[40px] desktop:py-[55px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-6 flex flex-col gap-2 tablet:mb-9 tablet:w-[605px] tablet:gap-4 desktop:w-[875px] desktop:gap-[22px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-h3 max-w-[400px] self-center px-4 text-center tablet:p-0 desktop:max-w-none",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-body-2 hidden max-w-[800px] text-center tablet:block",
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("no-scrollbar w-full touch-pan-x overflow-y-hidden overflow-x-scroll", labels.length < 5 && "flex tablet:items-center tablet:justify-center"),
                ref: samplesRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("flex touch-pan-x gap-2 px-4 tablet:gap-3"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-10 w-[calc(50vw-500px)] shrink-0"
                        }),
                        labels.map(function(style, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(usecases_ImageWithLabel, {
                                source: style.thumb,
                                label: style.name.toUpperCase()
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-10 w-[calc(50vw-500px)] min-w-[16px] shrink-0"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-body-2 mt-6 w-full max-w-[800px] px-4 text-center tablet:mt-9 tablet:hidden tablet:px-0",
                children: subtitle
            }),
            button_text && tool !== "ai_music_generator" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                        href: button_link,
                        onClick: function() {
                            onClick && onClick();
                        },
                        loading: editor.loading,
                        className: "mt-8 hidden max-w-[250px] desktop:block",
                        text: button_text,
                        primary: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex w-full items-center justify-center px-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* ConditionalAnchor */.hq, {
                            href: branch/* appStoreConstant */.HY,
                            className: " w-full tablet:mt-9 tablet:w-[250px] desktop:hidden",
                            children: button_text
                        })
                    })
                ]
            }),
            button_text && tool === "ai_music_generator" && /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                loading: editor.loading,
                primary: true,
                onClick: onClick,
                text: button_text,
                className: "mt-6 w-full tablet:mt-9 tablet:w-[250px] desktop:mt-8 desktop:max-w-[250px]"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./comps/feature/usecases-alternative.tsx







var usecasesAlternativeSchema = lib.z.object({
    component: lib.z.literal("usecases_alternative"),
    videos: lib.z.string().array(),
    style: lib.z.literal("large").optional(),
    background_images: lib.z.object({
        odd: lib.z.string(),
        even: lib.z.string()
    }).optional()
});
function UsecasesAlternative(props) {
    var videos = props.videos, style = props.style;
    var ref = (0,react.useState)(false), unmuteAll = ref[0], setUnmuteAll = ref[1];
    if (style && style === "large") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UseCasesLarge, (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (0,clsx_m/* default */.Z)("flex items-center overflow-x-auto py-[35px] tablet:py-[40px]", "no-scrollbar gap-[17px] desktop:gap-[20px] desktop:py-[120px]", "px-[20px] tablet:justify-center tablet:px-0"),
        children: videos.map(function(video, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onMouseMove: function() {
                    if (!unmuteAll) return;
                    var _$video = document.getElementById("usecase-video-".concat(index));
                    if ((0,_instanceof/* default */.Z)(_$video, HTMLVideoElement)) {
                        if (!_$video) return;
                        _$video.muted = false;
                    }
                },
                onMouseLeave: function() {
                    var _$video = document.getElementById("usecase-video-".concat(index));
                    if ((0,_instanceof/* default */.Z)(_$video, HTMLVideoElement)) {
                        if (!_$video) return;
                        _$video.muted = true;
                    }
                },
                className: "group relative z-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        id: "usecase-video-".concat(index),
                        src: video + "#t=0.001",
                        loop: true,
                        autoPlay: true,
                        playsInline: true,
                        muted: true,
                        className: (0,clsx_m/* default */.Z)("h-[201px] w-[125px] shrink-0 rounded-[14px] object-cover", "bg-blue-100 tablet:h-[272px] tablet:w-[169px]", "desktop:h-[362px] desktop:w-[224px]")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            setUnmuteAll(function(oldState) {
                                return !oldState;
                            });
                            var _$video = document.getElementById("usecase-video-".concat(index));
                            if ((0,_instanceof/* default */.Z)(_$video, HTMLVideoElement)) {
                                if (!_$video) return;
                                if (unmuteAll) {
                                    _$video.muted = true;
                                } else {
                                    _$video.muted = false;
                                }
                            }
                        },
                        className: (0,clsx_m/* default */.Z)("hidden bg-color-popup group-hover:block", "absolute bottom-2 rounded-[4px] p-[4px]", "right-2 z-20"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,cdn/* assetUrl */.p)("/general/".concat(unmuteAll ? "sound-on-v2" : "sound-off-v2", ".webp")),
                            alt: "sound icon",
                            className: "h-[24px] w-[24px]"
                        })
                    })
                ]
            }, index);
        })
    });
}
function UseCasesLarge(props) {
    var videos = props.videos, background_images = props.background_images;
    var ref = (0,react.useState)(false), unmuteAll = ref[0], setUnmuteAll = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (0,clsx_m/* default */.Z)("flex w-full py-[16px] tablet:py-[40px]", "no-scrollbar desktop:py-[60px]", " desktop:px-[calc(50vw-702px)]"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)("flex w-full flex-row items-center overflow-x-auto", "no-scrollbar gap-[14px] tablet:gap-3 desktop:gap-[24px]", " justify-start px-5 tablet:justify-center desktop:justify-start desktop:px-[30px]"),
            children: videos.map(function(video, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("h-[250px] w-[158px] shrink-0 overflow-hidden rounded-[6px]", "object-cover tablet:rounded-[8px] desktop:rounded-[14px]", "tablet:h-[290px] tablet:w-[173px]", "desktop:h-[492px] desktop:w-[318px]", "group relative z-10 p-[10px] tablet:p-3 desktop:px-[18px] desktop:py-[15px]"),
                    onMouseMove: function() {
                        if (!unmuteAll) return;
                        var _$video = document.getElementById("usecase-video-".concat(index));
                        if ((0,_instanceof/* default */.Z)(_$video, HTMLVideoElement)) {
                            if (!_$video) return;
                            _$video.muted = false;
                        }
                    },
                    onMouseLeave: function() {
                        var _$video = document.getElementById("usecase-video-".concat(index));
                        if ((0,_instanceof/* default */.Z)(_$video, HTMLVideoElement)) {
                            if (!_$video) return;
                            _$video.muted = true;
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            id: "usecase-video-".concat(index),
                            src: video + "#t=0.001",
                            loop: true,
                            playsInline: true,
                            autoPlay: true,
                            muted: true,
                            className: (0,clsx_m/* default */.Z)("relative z-10 h-full w-full shrink-0 rounded-[2px]", "object-cover tablet:rounded-[4px] desktop:rounded-[8px]")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: function() {
                                setUnmuteAll(function(oldState) {
                                    return !oldState;
                                });
                                var _$video = document.getElementById("usecase-video-".concat(index));
                                if ((0,_instanceof/* default */.Z)(_$video, HTMLVideoElement)) {
                                    if (!_$video) return;
                                    if (unmuteAll) {
                                        _$video.muted = true;
                                    } else {
                                        _$video.muted = false;
                                    }
                                }
                            },
                            className: (0,clsx_m/* default */.Z)("hidden bg-color-popup group-hover:block", "absolute bottom-6 rounded-[4px]", "right-[26px] z-20 h-7 w-7 p-1"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,cdn/* assetUrl */.p)("/general/".concat(unmuteAll ? "sound-on-v2" : "sound-off-v2", ".webp")),
                                alt: "sound icon",
                                className: "h-full w-full"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            style: {
                                display: index % 2 === 0 ? "none" : "block"
                            },
                            src: background_images ? background_images.odd : (0,cdn/* assetUrl */.p)("/feature/odd-bg.webp"),
                            alt: "background odd",
                            className: "absolute left-0 top-0 z-0 h-full w-full object-cover"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            style: {
                                display: index % 2 !== 0 ? "none" : "block"
                            },
                            src: background_images ? background_images.even : (0,cdn/* assetUrl */.p)("/feature/even-bg.webp"),
                            alt: "background even",
                            className: "absolute left-0 top-0 h-full w-full"
                        })
                    ]
                }, index);
            })
        })
    });
}

// EXTERNAL MODULE: ./comps/footer/index.tsx + 4 modules
var footer = __webpack_require__(8109);
// EXTERNAL MODULE: ./comps/home/platforms/runner.tsx
var runner = __webpack_require__(4593);
// EXTERNAL MODULE: ./comps/index.tsx + 6 modules
var comps = __webpack_require__(8014);
;// CONCATENATED MODULE: ./pages/feature/[feature].tsx



























var _feature_featureAiToolSchema = lib.z["enum"]([
    "deform",
    "ai_photo",
    "ai_restyle",
    "text_to_image",
    "text_to_video",
    "ai_music_generator", 
]);
var __N_SSP = true;
var templateComponentAlternative = lib.z.object({
    component: lib.z.literal("templates-alternative"),
    title: lib.z.string(),
    description: lib.z.string(),
    button_text: lib.z.string(),
    button_link: lib.z.string(),
    bubble_text: lib.z.string(),
    templates: lib.z.array(lib.z.string())
});
var templateComponent = lib.z.object({
    component: lib.z.literal("templates"),
    title: lib.z.string(),
    button_link: lib.z.string().optional(),
    button_text: lib.z.string().optional(),
    templates: lib.z.array(lib.z.string()),
    upload: lib.z.boolean().optional(),
    tool: _feature_featureAiToolSchema.optional()
});
var PageContext = /*#__PURE__*/ (0,react.createContext)(null);
function _feature_useFeaturePage() {
    var context = (0,react.useContext)(PageContext);
    if (!context) throw new Error("You forgot the context");
    return context;
}
var runnerSchema = lib.z.object({
    component: lib.z.literal("runner")
});
var metaSchema = lib.z.object({
    component: lib.z.literal("meta"),
    title: lib.z.string(),
    description: lib.z.string(),
    cover: lib.z.string().optional(),
    ratingValue: lib.z.number().optional(),
    ratingCount: lib.z.number().optional(),
    reviewCount: lib.z.number().optional()
});
var singleFeatureSchema = lib.z.union([
    metaSchema,
    introSchema,
    infoLeftRightSchema,
    headlineSchema,
    runnerSchema,
    achievementSchema,
    tutorialSchema,
    templateComponent,
    styleSchema,
    suggestedStyleSchema,
    usecasesSchema,
    benefitsSchema,
    reviews/* reviewComponent */.LI,
    questionComponent,
    toolComponent,
    templateComponentAlternative,
    usecasesAlternativeSchema,
    headlineAlternativeSchema,
    infoButtonSchema,
    textSchema,
    callToActionSchema,
    textareaSchema, 
]);
var featureSchema = lib.z.array(singleFeatureSchema);
function isFaq(component) {
    return component.component === "faq";
}
function isHeadline(component) {
    return component.component === "headline";
}
function isMeta(component) {
    return component.component === "meta";
}
function isReview(component) {
    return component.component === "reviews";
}
function getJsonLdData(components, slug) {
    var ref;
    var faqComponent = (ref = components.filter(isFaq).at(0)) !== null && ref !== void 0 ? ref : null;
    var ref1;
    var headlineComponent = (ref1 = components.filter(isHeadline).at(0)) !== null && ref1 !== void 0 ? ref1 : null;
    var ref2;
    var metaComponent = (ref2 = components.filter(isMeta).at(0)) !== null && ref2 !== void 0 ? ref2 : null;
    var ref3;
    var _$reviewComponent = (ref3 = components.filter(isReview).at(0)) !== null && ref3 !== void 0 ? ref3 : null;
    var ref4;
    var questions = (ref4 = faqComponent === null || faqComponent === void 0 ? void 0 : faqComponent.questions) !== null && ref4 !== void 0 ? ref4 : null;
    var ref5;
    var headline = (ref5 = headlineComponent === null || headlineComponent === void 0 ? void 0 : headlineComponent.title) !== null && ref5 !== void 0 ? ref5 : null;
    var ref6;
    var description = (ref6 = metaComponent === null || metaComponent === void 0 ? void 0 : metaComponent.description) !== null && ref6 !== void 0 ? ref6 : null;
    var ref7;
    var person = (ref7 = _$reviewComponent === null || _$reviewComponent === void 0 ? void 0 : _$reviewComponent.reviews[0]) !== null && ref7 !== void 0 ? ref7 : null;
    var ref8, ref9, ref10;
    var scripts = [
        {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
                {
                    "@type": "ListItem",
                    position: "0",
                    name: "Home",
                    item: "https://zoomerang.app/"
                },
                {
                    "@type": "ListItem",
                    position: "1",
                    name: "Tools",
                    item: "https://zoomerang.app/tools"
                },
                {
                    "@type": "ListItem",
                    position: "2",
                    name: headline !== null && headline !== void 0 ? headline : slug,
                    item: "https://zoomerang.app/tools/" + slug
                }, 
            ]
        },
        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            name: headline !== null && headline !== void 0 ? headline : slug,
            aggregateRating: {
                "@type": "AggregateRating",
                ratingValue: (ref8 = metaComponent === null || metaComponent === void 0 ? void 0 : metaComponent.ratingValue) !== null && ref8 !== void 0 ? ref8 : 5,
                ratingCount: (ref9 = metaComponent === null || metaComponent === void 0 ? void 0 : metaComponent.ratingCount) !== null && ref9 !== void 0 ? ref9 : 21,
                reviewCount: (ref10 = metaComponent === null || metaComponent === void 0 ? void 0 : metaComponent.reviewCount) !== null && ref10 !== void 0 ? ref10 : 17,
                bestRating: "5",
                worstRating: "0"
            },
            applicationCategory: "MultimediaApplication",
            offers: {
                "@type": "Offer",
                price: "0",
                priceCurrency: "USD"
            }
        }, person !== null && {
            review: {
                "@type": "Review",
                author: {
                    "@type": "Person",
                    name: person.name
                },
                reviewRating: {
                    "@type": "Rating",
                    ratingValue: "5",
                    worstRating: "0",
                    bestRating: "5"
                },
                description: person.opinion
            }
        }), {
            operatingSystem: "Windows, Mac OS, Linux, Chrome OS, iOS, Android",
            description: description !== null && description !== void 0 ? description : slug,
            url: "https://zoomerang.app/tools/" + slug,
            applicationSubCategory: headline !== null && headline !== void 0 ? headline : slug
        }), 
    ];
    if (questions) {
        var questionScript = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: questions.map(function(a) {
                return {
                    "@type": "Question",
                    name: a.question,
                    acceptedAnswer: {
                        "@type": "Answer",
                        text: a.answer
                    }
                };
            })
        };
        scripts.push(questionScript);
    }
    return scripts;
}
var RenderComponent = function(props) {
    var item = props.item, jsonLd = props.jsonLd;
    switch(item.component){
        case "meta":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(comps/* Meta */.h_, {
                title: item.title,
                description: item.description,
                cover: item.cover,
                jsonLdData: jsonLd
            });
        case "intro":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroLanding, (0,_object_spread/* default */.Z)({}, item));
        case "headline":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadlineCover, (0,_object_spread/* default */.Z)({}, item));
        case "runner":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(runner["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                className: "py-[16px] tablet:pt-[40px] desktop:pt-[55px]"
            }));
        case "achievements":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(achievements, (0,_object_spread/* default */.Z)({}, item));
        case "how_to_make":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HowToMake, (0,_object_spread/* default */.Z)({}, item));
        case "templates":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedTemplates, (0,_object_spread/* default */.Z)({}, item));
        case "suggested-styles":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StylesSection, (0,_object_spread/* default */.Z)({}, item));
        case "usecases":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Usecases, (0,_object_spread/* default */.Z)({}, item));
        case "templates-alternative":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedTemplatesAlternative, (0,_object_spread/* default */.Z)({}, item));
        case "styles":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styles, (0,_object_spread/* default */.Z)({}, item));
        case "benefits":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Benefits, (0,_object_spread/* default */.Z)({}, item));
        case "reviews":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(reviews/* default */.ZP, (0,_object_spread/* default */.Z)({}, item));
        case "faq":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ, (0,_object_spread/* default */.Z)({}, item));
        case "tools":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tools, (0,_object_spread/* default */.Z)({}, item));
        case "usecases_alternative":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(UsecasesAlternative, (0,_object_spread/* default */.Z)({}, item));
        case "headline_alternative":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadlineAlternative, (0,_object_spread/* default */.Z)({}, item));
        case "info-left-right":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoLeftRight, (0,_object_spread/* default */.Z)({}, item));
        case "info-button":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoButton, (0,_object_spread/* default */.Z)({}, item));
        case "text":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, (0,_object_spread/* default */.Z)({}, item));
        case "call-to-action":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction, (0,_object_spread/* default */.Z)({}, item));
        case "headline-textarea":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadlineTextArea, (0,_object_spread/* default */.Z)({}, item));
    }
};
function Feature(props) {
    var content = props.content, page = props.page, templates = props.templates;
    var parsedJson = JSON.parse(content);
    var parsed = featureSchema.parse(parsedJson);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContext.Provider, {
        value: {
            page: page,
            templates: templates
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full flex-col bg-color-cell",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(comps/* Header */.h4, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex w-full flex-col bg-color-cell",
                    children: parsed.map(function(componentData, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderComponent, {
                            item: componentData,
                            jsonLd: getJsonLdData(parsed, page)
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* WrappedFooter */.M, {})
            ]
        })
    });
}


/***/ }),

/***/ 2308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ isStringUrl; }
/* harmony export */ });
function isStringUrl(str) {
    if (str.startsWith("http")) {
        return {
            website_url: str,
            initial_message: null
        };
    }
    return {
        website_url: null,
        initial_message: str
    };
}


/***/ }),

/***/ 9480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dw": function() { return /* binding */ notEmpty; },
/* harmony export */   "Jh": function() { return /* binding */ isEmail; },
/* harmony export */   "Mn": function() { return /* binding */ isPhone; }
/* harmony export */ });
/* unused harmony export isPhoneOrEmpty */
/* harmony import */ var _swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9637);

var notEmpty = function(value, t) {
    if (value.length === 0) return t("txt_error_not_empty");
};
var isEmail = function(value, t) {
    var atIndex = value.indexOf("@");
    var dotIndex = value.lastIndexOf(".");
    var atSymbols = value.split("@");
    if (atIndex === 0) return t("txt_error_cannot_start_with_at");
    if (atIndex === -1) return t("txt_error_should_contain_at");
    if (dotIndex === -1 || dotIndex < atIndex || dotIndex === value.length - 1) return t("txt_error_email_wrong_domain");
    if (atSymbols.length > 2) return t("txt_error_email_one_at");
};
var isPhone = function(value, t) {
    var plusIndex = value.lastIndexOf("+");
    if (plusIndex !== 0 && plusIndex !== -1) return t("txt_error_plus_middle");
    var ref = (0,_swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value.split("")), _ = ref[0], numbers = ref.slice(1);
    if (numbers.join("").match(/[^0-9\s]/) !== null) return t("txt_error_only_numbers_and_plus");
    if (value.length <= 6) return t("txt_error_short_phone");
    if (value[0] !== "0" && value[0] !== "+") return t("txt_error_phone_format");
};
var isPhoneOrEmpty = function(value, t) {
    if (!value) {
        return undefined;
    }
    return isPhone(value, t);
};


/***/ }),

/***/ 5017:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"letter-row":"cover_letter-row__l1Jwh","each-letter":"cover_each-letter__VWVC3","letter-appear":"cover_letter-appear__Xby_k","animation-container":"cover_animation-container__hn9cf","animation-container-full":"cover_animation-container-full__hdWqe","column-container":"cover_column-container__JFykj","rounded-image":"cover_rounded-image__lhASh","rounded-image-small":"cover_rounded-image-small__xxWV0","animated-image":"cover_animated-image__n8eTN","image-appear-first":"cover_image-appear-first__8l2in","image-appear-second":"cover_image-appear-second__9IXMe","image-appear-others":"cover_image-appear-others__6N5h0","bottom-text":"cover_bottom-text__JjaSE","start-free":"cover_start-free__9EmbK","stores":"cover_stores__sUmb2","background-appear":"cover_background-appear__VBnFL","half-spin":"cover_half-spin__U5CVD"};

/***/ }),

/***/ 9637:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9474);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3375);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3128);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1566);





function _toArray(arr) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ })

}]);